var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M295.88,48.87l.3,5.55a4.7,4.7,0,0,1,3-1.31,4.81,4.81,0,1,1-2.63,8.63l.3,5.56a4.68,4.68,0,0,1,3-1.31,4.81,4.81,0,0,1,.52,9.61,4.74,4.74,0,0,1-3.15-1l.3,5.57a4.64,4.64,0,0,1,3-1.32,4.81,4.81,0,0,1,.52,9.61,4.69,4.69,0,0,1-3.15-1l.3,5.57a4.69,4.69,0,0,1,3-1.32,4.81,4.81,0,0,1,.52,9.61,4.69,4.69,0,0,1-3.15-1l.3,5.57a4.69,4.69,0,0,1,3-1.32,4.81,4.81,0,0,1,.52,9.61,4.69,4.69,0,0,1-3.15-1l.29,5.57a4.74,4.74,0,0,1,3-1.32,4.81,4.81,0,0,1,.51,9.61,4.68,4.68,0,0,1-3.14-1l.18,3.45,148.32-7.93-4.31-80.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.06,56.91c0,.14-33.19,2-74.14,4.22S296.74,65,296.74,64.84s33.18-2,74.15-4.23S445.05,56.76,445.06,56.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75,69.82c0,.14-33.19,2-74.14,4.23s-74.18,3.85-74.18,3.71,33.18-2,74.15-4.23S445.74,69.68,445.75,69.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.44,82.74c0,.14-33.19,2-74.14,4.22s-74.17,3.86-74.18,3.71,33.18-2,74.15-4.23S446.43,82.59,446.44,82.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.13,95.65c0,.15-33.19,2-74.14,4.23s-74.17,3.85-74.18,3.71,33.18-2,74.15-4.23S447.13,95.51,447.13,95.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.82,108.57c0,.14-33.19,2-74.14,4.22s-74.17,3.86-74.18,3.71,33.19-2,74.15-4.23S447.82,108.42,447.82,108.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.41,
    y: 47.71,
    width: 0.5,
    height: 80.84,
    transform: "translate(-4.25 17.15) rotate(-3.06)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.26,127.77c-.14,0-1.23-18.06-2.42-40.34s-2-40.38-1.9-40.38,1.23,18,2.42,40.35S334.4,127.76,334.26,127.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.85,129.18c-.14,0-1.22-18.05-2.41-40.34s-2.05-40.37-1.9-40.38,1.22,18.05,2.42,40.35S308,129.18,307.85,129.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,127c-.14,0-1.23-18.06-2.42-40.35s-2-40.37-1.9-40.38,1.23,18.06,2.42,40.35S348.86,127,348.72,127Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.18,126.22c-.14,0-1.22-18-2.42-40.34s-2-40.37-1.9-40.38,1.23,18,2.42,40.35S363.33,126.22,363.18,126.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.64,125.45c-.14,0-1.22-18.06-2.42-40.35s-2-40.37-1.9-40.37,1.23,18.05,2.42,40.35S377.79,125.44,377.64,125.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.1,124.68c-.14,0-1.22-18.06-2.41-40.35S387.64,44,387.79,44,389,62,390.21,84.3,392.25,124.67,392.1,124.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.57,123.9c-.15,0-1.23-18.06-2.42-40.34s-2-40.37-1.9-40.38,1.22,18,2.42,40.35S406.71,123.9,406.57,123.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,123.13c-.15,0-1.23-18.06-2.42-40.35s-2.05-40.37-1.9-40.38,1.22,18.06,2.42,40.35S421.17,123.12,421,123.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.49,122.36c-.15,0-1.23-18.06-2.42-40.35s-2-40.37-1.9-40.38,1.23,18,2.42,40.35S435.63,122.35,435.49,122.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.48,57.34c.66,3.2,2,6.46,4.74,8.31a8.48,8.48,0,0,0,12.43-10.71,8.74,8.74,0,0,0-9.31-4.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.87,
    cy: 56.95,
    r: 6.75,
    transform: "translate(4.21 133.83) rotate(-23.86)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.25,54.81a4.05,4.05,0,1,0,3.83-4.26A4,4,0,0,0,308.25,54.81Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312,58.56a13.81,13.81,0,0,0,1.51-.23A3.88,3.88,0,0,0,316.05,56a4.18,4.18,0,0,0-.41-3.43c-.48-.8-1-1.12-1-1.2s.65.17,1.26,1a4.2,4.2,0,0,1,.6,3.81,4,4,0,0,1-2.92,2.51A2.11,2.11,0,0,1,312,58.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.41,52.12a9.37,9.37,0,0,0,2.36,0c1.26-.28,2-1.16,2.1-1.06s-.05.32-.38.66a3.26,3.26,0,0,1-1.61.91,3.2,3.2,0,0,1-1.84-.12C315.6,52.38,315.38,52.18,315.41,52.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.46,62.38A7.79,7.79,0,0,0,315,59.94a7.87,7.87,0,0,0-2.52-1.32c0-.06.35-.14.91,0a3.75,3.75,0,0,1,2,1,3.82,3.82,0,0,1,1.1,1.9C316.58,62,316.52,62.37,316.46,62.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.5,52.57c.65,3.21,2,6.46,4.74,8.32a8.48,8.48,0,0,0,12.42-10.72,8.74,8.74,0,0,0-9.3-4.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 433.02,
    cy: 51.09,
    r: 6.52,
    transform: "translate(240.69 442.41) rotate(-70.56)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,48a3.92,3.92,0,1,1-4.12-3.7A3.9,3.9,0,0,1,443,48Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.76,51.94a2,2,0,0,1-1.52.29,3.85,3.85,0,0,1-3.07-2.12,4.07,4.07,0,0,1,.18-3.73c.51-.85,1.09-1.12,1.12-1.07a11.55,11.55,0,0,0-.79,1.25,4,4,0,0,0,0,3.33,3.75,3.75,0,0,0,2.65,2C439.17,52,439.74,51.85,439.76,51.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.84,46.1s-.15.27-.56.49a3.19,3.19,0,0,1-3.4-.41c-.35-.3-.47-.56-.42-.61a8.92,8.92,0,0,0,2.12.8A9.34,9.34,0,0,0,435.84,46.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.89,56.06c-.06,0-.16-.33-.1-.88a3.7,3.7,0,0,1,2.65-3.1c.53-.15.88-.1.88,0a8,8,0,0,0-2.27,1.53A7.7,7.7,0,0,0,435.89,56.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327,
    y: 182.79,
    width: 128.84,
    height: 42.76,
    transform: "translate(18.33 -31.84) rotate(4.77)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.35,201c0,.15-21.54-1.53-48.07-3.75s-48-4.12-48-4.27,21.53,1.54,48.07,3.75S439.36,200.86,439.35,201Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.09,212.13c0,.14-21.53-1.54-48.06-3.75s-48-4.13-48-4.27,21.53,1.53,48.06,3.75S439.1,212,439.09,212.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "367.06 174.57 416.81 178.72 414.19 180.94 417.6 183.91 413.54 185.77 417.17 189 365.03 184.64 368.28 181.89 366.67 178.94 369.46 177.52 367.06 174.57",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.84,124.93c-.2,3-.39,6-.59,8.94l8.77.55q.27-4.35.57-8.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24,123.65q-.3,4.63-.6,9.08l8.57.52q.28-4.41.58-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.38,148.18l3.21.22.63-8.37-3.28-.2C141.75,142.68,141.56,145.47,141.38,148.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.86,139.27c-.19,2.83-.37,5.6-.55,8.29l8.43.57q.25-4.06.52-8.34Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.45,126.17q-.3,4.53-.59,8.87l9,.58c.19-2.89.37-5.85.57-8.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.88,128c-.2,3-.39,6-.58,8.86l8.1.54c.19-2.9.38-5.85.57-8.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.28,125.56q-.3,4.55-.59,8.9l8.5.54q.27-4.33.57-8.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.05,127.39c-.19,3-.39,6-.58,8.85l.32,0,8.83.58q.28-4.34.57-8.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.09,138.72c-.18,2.82-.37,5.57-.54,8.25l8.11.55c.17-2.7.35-5.46.53-8.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.08,126.8q-.3,4.53-.58,8.86l8.3.54q.27-4.33.56-8.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.61,133.2c-.19,2.88-.38,5.7-.56,8.43l8.6.52q.26-4.07.53-8.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.85,133.84c-.19,2.85-.37,5.65-.55,8.35l8.72.54q.25-4,.52-8.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.66,128.59q-.3,4.53-.58,8.87l8.38.56q.29-4.35.57-8.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73,157.87l3.13.22.69-9.16-3.2-.2Q141,153.47,140.73,157.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,148.17q-.32,4.71-.61,9.09l8.47.57q.27-4.4.57-9.14Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.21,134.48c-.18,2.83-.37,5.61-.55,8.29l8.8.55c.16-2.67.34-5.43.52-8.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.45,136.35q-.28,4.22-.55,8.22l8.34.53c.16-2.65.34-5.4.51-8.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.74,137l-.32,0c-.18,2.8-.36,5.55-.54,8.21l9.18.6q.25-4,.52-8.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.25,137.58c-.18,2.8-.37,5.54-.54,8.21l8.13.53c.17-2.66.34-5.41.52-8.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.82,135.72c-.19,2.81-.37,5.56-.55,8.23l9,.57q.26-4,.52-8.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.65,135.11c-.19,2.82-.37,5.58-.55,8.25l8.53.55c.17-2.67.34-5.42.52-8.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,138.14c-.18,2.81-.37,5.56-.54,8.23l8.41.56c.17-2.68.34-5.44.52-8.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.48,124.29q-.3,4.6-.59,9l8.69.54q.29-4.38.57-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.31,120.11c-.18,2.84-.37,5.65-.55,8.4l8.08.55c.17-2.77.35-5.59.54-8.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,107.06,61,106.47q-.23,3.5-.46,7.08c0,.57-.07,1.14-.11,1.71l8.74.55.09-1.41Q69.54,110.68,69.78,107.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,105.78l-8.54-.59c-.15,2.36-.31,4.74-.46,7.15l-.12,1.78,8.55.52c0-.55.07-1.1.1-1.65Q50.75,109.35,51,105.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,129.72,146,130l.64-8.52-3.45-.21Q142.88,125.54,142.6,129.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,107.67l-8.48-.57q-.23,3.63-.47,7.34l-.09,1.42,8.47.53c0-.56.08-1.12.11-1.68C78.65,112.33,78.8,110,79,107.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.08,120.66q-.29,4.29-.55,8.44l8.38.57c.18-2.78.36-5.62.55-8.49Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.35,106.42l-8.67-.59c-.16,2.37-.31,4.77-.47,7.2,0,.56-.07,1.1-.11,1.66l8.67.53.12-1.72Q60.11,109.92,60.35,106.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.5,147.62q-.31,4.69-.6,9l8.16.55q.27-4.38.56-9.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.16,110.09l-8.08-.52c-.17,2.53-.33,5.1-.5,7.69,0,.34,0,.68-.07,1l8.09.53c0-.57.07-1.13.11-1.69Q115.94,113.55,116.16,110.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.56,108.89l-8.29-.54c-.15,2.47-.32,5-.48,7.5,0,.41-.05.8-.08,1.21l8.28.53c0-.56.07-1.12.11-1.68Q97.33,112.36,97.56,108.89Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.38,109.52l-9.13-.59q-.23,3.48-.45,7c0,.56-.08,1.12-.11,1.68l.31,0,8.82.57.06-1Q107.14,113.32,107.38,109.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.58,108.3l-8.94-.59c-.14,2.32-.3,4.67-.45,7,0,.57-.07,1.13-.11,1.69L88,117c0-.4.06-.8.08-1.2Q88.35,112,88.58,108.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.67,117.75q-.28,4.25-.55,8.36l8.29.54q.25-4.11.54-8.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.43,115.87c-.18,2.86-.37,5.68-.55,8.45l8.75.55c.17-2.76.36-5.57.54-8.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.25,119.53c-.18,2.84-.37,5.63-.55,8.38l8.37.56q.27-4.14.54-8.41Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,114.59c-.19,2.91-.37,5.77-.56,8.59,2.64.15,5.5.33,8.55.52q.27-4.2.55-8.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,139.27l3.29.23.67-9-3.36-.2Q142.27,134.87,142,139.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.49,129.71c-.2,3-.4,6-.59,8.94l8.4.57q.28-4.4.57-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.07,115.23c-.19,2.88-.37,5.72-.56,8.51l8.68.53q.27-4.15.55-8.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.87,116.5q-.28,4.27-.55,8.41l8.48.54c.18-2.75.36-5.55.54-8.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,118.35l-.31,0q-.27,4.24-.54,8.36l9.13.6q.27-4.12.54-8.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.47,119c-.18,2.83-.37,5.62-.55,8.36l8.09.54c.18-2.75.36-5.55.54-8.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.72,129.16q-.3,4.54-.58,8.9l8.09.55q.27-4.38.57-8.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,117.11c-.19,2.84-.37,5.64-.55,8.38l8.94.58q.27-4.12.54-8.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,153.08c-.19,2.85-.38,5.57-.55,8.14l8.89.56c.16-2.57.32-5.27.5-8.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77,160.56c-.23,3.39-.45,6.53-.65,9.38l8.79.53c.17-2.83.36-5.94.56-9.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,161.2c-.23,3.36-.45,6.47-.65,9.3l8.92.55c.17-2.82.36-5.91.56-9.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78,186l3,.21.67-9-3-.18C139.18,180.44,139,183.46,138.78,186Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.57,175.92c-.23,3.38-.45,6.36-.63,8.87l8.43.56c.14-2.53.31-5.52.52-8.91Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34,176.47c-.24,3.39-.45,6.38-.63,8.91l8.73.59c.15-2.54.32-5.55.52-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,164.26l-8.34-.55q-.35,5-.63,9.16l8.52.55c.16-2.79.35-5.85.55-9.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.51,175.35c-.24,3.41-.45,6.36-.64,8.83l8.74.58c.14-2.5.31-5.49.51-8.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.58,164.3c-.22,3.3-.43,6.36-.63,9.15l.42,0,8.95.58c.17-2.8.35-5.86.55-9.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.37,161.83c-.22,3.35-.44,6.44-.64,9.25l9,.56c.16-2.81.35-5.88.55-9.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,147c-.21,3.12-.41,6.14-.61,9l8.46.56q.27-4.35.57-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81,162.47q-.34,5-.64,9.2l8.72.55c.17-2.79.35-5.86.55-9.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.29,172.93c-.24,3.41-.45,6.37-.63,8.84l9.31.6c.14-2.49.31-5.46.51-8.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.09,170.4c-.25,3.51-.47,6.54-.65,9.06l8.92.54c.14-2.51.32-5.52.52-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,50.2,149.38,50a6.72,6.72,0,0,1,.69,3.49,6.64,6.64,0,0,1-1.72,4l3.05.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.33,171c-.25,3.47-.46,6.47-.65,9l9,.56q.21-3.75.52-8.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.81,45.22A6.61,6.61,0,0,1,41,41.88l-4.89-.37-.65,8.73,6.46.37A6.68,6.68,0,0,1,39.81,45.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.73,174.78c-.24,3.37-.45,6.34-.63,8.83l8.45.55c.14-2.47.31-5.43.51-8.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.22,110.66l-8.36-.53q-.23,3.48-.46,7c0,.57-.07,1.13-.11,1.7l8.36.55.06-.85Q125,114.56,125.22,110.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.93,173.56c-.24,3.38-.45,6.34-.63,8.83L93,183c.14-2.47.31-5.43.51-8.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.69,171.68c-.24,3.44-.46,6.43-.64,8.92l9.12.57c.14-2.5.31-5.47.51-8.88Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,174.17l-.43,0c-.24,3.4-.45,6.35-.63,8.82l1.17.07,8.33.55c.14-2.5.31-5.47.51-8.84Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,164.93q-.33,5-.63,9.16l8.33.55q.24-4.2.55-9.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.13,172.32c-.24,3.41-.46,6.38-.64,8.87l8.85.56c.14-2.48.31-5.44.51-8.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,163.08c-.23,3.31-.44,6.38-.64,9.17l9.18.59c.17-2.8.35-5.86.55-9.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.26,142.74c-.21,3.17-.42,6.23-.62,9.16l8.77.54c.18-2.91.37-5.95.57-9.1Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,142.1c-.21,3.2-.42,6.29-.62,9.24l8.65.52c.18-2.93.37-6,.57-9.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.62,143.38c-.21,3.15-.41,6.19-.61,9.09l8.84.56q.27-4.35.57-9.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.62,157.87c-.19,2.84-.38,5.56-.55,8.14l8.52.58q.24-3.9.51-8.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.14,166.63l3.06.21.62-8.22-3.12-.19C140.5,161.3,140.32,164,140.14,166.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.85,157.32q-.28,4.25-.55,8.1l8.22.56c.15-2.59.32-5.3.5-8.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,145.84c-.2,3.12-.41,6.13-.6,9l.35,0,8.87.58q.27-4.33.57-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.06,144q-.32,4.69-.61,9l8.57.54q.27-4.34.57-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66,146.48q-.31,4.68-.6,9l8.18.54c.18-2.89.36-5.91.56-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.86,145.26q-.31,4.68-.61,9l8.38.54c.18-2.88.37-5.89.56-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.23,144.62q-.32,4.69-.61,9l9,.58q.27-4.33.57-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.19,165.5c-.23,3.31-.44,6.38-.63,9.17l8.6.57c.17-2.81.35-5.89.55-9.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.46,176.48l3,.2.69-9.31-3.06-.19C139.87,170.53,139.66,173.64,139.46,176.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.61,152.44c-.2,2.87-.38,5.61-.56,8.2l8.83.55q.23-3.87.5-8.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.37,151.8q-.3,4.35-.56,8.28l8.7.53c.16-2.6.32-5.34.5-8.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.26,166.07q-.35,5-.64,9.2l8.3.56c.17-2.83.36-5.92.56-9.24Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,166.62c-.22,3.32-.44,6.41-.64,9.24l8.62.59c.17-2.85.35-5.95.56-9.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.54,155.57l-.36,0c-.19,2.81-.37,5.5-.55,8l9.29.61c.15-2.56.32-5.25.49-8.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.41,153.71c-.2,2.84-.38,5.54-.56,8.11l8.63.55c.16-2.56.33-5.26.5-8.08Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,156.18c-.19,2.82-.37,5.5-.55,8.06l8.24.54c.15-2.55.32-5.25.49-8.07Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.79,156.74c-.19,2.82-.38,5.52-.55,8.08l8.51.57q.24-3.87.5-8.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.58,154.32c-.2,2.82-.38,5.52-.55,8.08l9.08.58c.16-2.56.33-5.24.5-8.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.21,155c-.19,2.82-.38,5.5-.55,8.06l8.33.54h.1c.16-2.55.32-5.24.5-8.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34,58.76c-.17,2.8-.35,5.83-.55,9.05l8.68.52q.33-4.78.62-9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.48,56.87a6.26,6.26,0,0,1,.75,0,8.59,8.59,0,0,1,2.23.34,10.76,10.76,0,0,1,5.51.89c0-.78.11-1.53.16-2.26A6.87,6.87,0,0,1,100,55l-7.37-.48C92.57,55.24,92.53,56,92.48,56.87Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91,80.53q-.27,4.18-.55,8.67l8.33.53c.19-3,.39-5.86.57-8.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.85,62.11l4.69.31c.17-2.44.33-4.7.48-6.76l-2.44-.15a6.69,6.69,0,0,1-7,.58c0,.7-.09,1.43-.13,2.18A11.37,11.37,0,0,1,105.85,62.11Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.31,54.2a6.67,6.67,0,0,1-1.42-4.62,6.77,6.77,0,0,1,1.2-3.35l-6-.45c-.12,2.11-.27,4.79-.45,8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41,79.9q-.27,4.2-.55,8.68l9,.57q.3-4.47.58-8.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,78q-.27,4.26-.55,8.81l8.71.54c.2-3,.4-5.93.58-8.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,56.67A5.18,5.18,0,0,1,88.26,58a1.16,1.16,0,0,1,.28.13,8.78,8.78,0,0,1,3.5-1.2c.06-.85.12-1.67.17-2.47L89,54.23a6.74,6.74,0,0,1-4.22,1.13,6.82,6.82,0,0,1-1.82-.43c0,.7-.09,1.42-.13,2.16A5.13,5.13,0,0,1,85,56.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,78.65c-.17,2.82-.36,5.74-.55,8.75L71,88c.2-3,.39-5.91.58-8.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.24,79.29c-.18,2.8-.36,5.71-.55,8.71l8.52.54c.2-3,.39-5.89.58-8.68Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,62.45l8.3.55c.15-2.22.3-4.3.43-6.21-.22-.19-.42-.4-.63-.61l-7.7-.49C111.3,57.75,111.17,60,111,62.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62,82.32c-.17,2.79-.35,5.69-.54,8.68l8.4.56c.2-3,.4-5.91.58-8.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,56.74v-.13a6.66,6.66,0,0,1,.14-7.47l-7.8-.59a6.73,6.73,0,0,1-.69,7.08l0,.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,63.6q.26-3.69.48-6.8l-.64,0a6.63,6.63,0,0,1-8.06.3c-.11,1.85-.23,3.85-.36,6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.91,56.1s0,0,0,0h0Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.64,47.18l-1-.08a6.83,6.83,0,0,1,.68,3.49,6.7,6.7,0,0,1-2,4.27l1.73.11C111.29,51.85,111.48,49.24,111.64,47.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,77.37c-.18,2.87-.36,5.83-.56,8.89l8.59.52q.3-4.55.59-8.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.37,81.14l-.36,0c-.17,2.79-.35,5.67-.54,8.66h.06l9.11.6c.2-3,.4-5.88.58-8.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.53,55.46A6.67,6.67,0,0,1,117.26,51a6.6,6.6,0,0,1,1.19-3.35l-6.55-.5c-.11,2.07-.26,4.68-.44,7.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84,81.75c-.18,2.79-.36,5.69-.54,8.67l8.12.53c.2-3,.39-5.88.58-8.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.25,91.11c-.17,2.78-.35,5.64-.54,8.56l8.1.53q.28-4.38.57-8.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.13,58.83c.17-2.49.33-4.8.48-6.91l-4.75-.33a6.68,6.68,0,0,1-3.83.86l-.31-.05c-.11,1.83-.22,3.8-.35,5.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.49,90.48h-.06c-.18,2.77-.36,5.63-.55,8.55l.33,0,8.82.58c.19-2.92.38-5.78.57-8.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.27,43l-2.7-.21a6.63,6.63,0,0,1,.68,3.49,6.7,6.7,0,0,1-2.73,4.9l4.13.25C54.89,48,55.1,45.14,55.27,43Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.45,89.89c-.17,2.78-.36,5.64-.54,8.56L98.2,99c.2-2.92.39-5.78.57-8.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82,89.26c-.17,2.78-.36,5.65-.54,8.57l9,.57c.19-2.92.38-5.78.56-8.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.64,170.37l-11.13-.8-.69,9.22,11.3.65C37.26,176.92,37.44,173.88,37.64,170.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,51.77a6.68,6.68,0,0,1-.61-8.44L55.53,43c-.12,2.21-.28,5-.48,8.44Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,60q.25-3.69.48-6.81l-4-.26a6.67,6.67,0,0,1-4,1,6.29,6.29,0,0,1-1.07-.18c-.1,1.77-.22,3.69-.34,5.72Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,91.67q-.25,4.18-.54,8.58l8.38.56q.28-4.41.57-8.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.1,53a6.71,6.71,0,0,1-.37-8.19l-5.41-.41c-.12,2.15-.27,4.91-.46,8.2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.09,92.25q-.25,4.19-.54,8.6l8.08.54q.3-4.42.58-8.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.42,60l6.43.41a5.17,5.17,0,0,1,2.48-3.1c.06-.89.12-1.75.18-2.57a6.7,6.7,0,0,1-1.68-1.08l-7-.47C73.7,55.3,73.56,57.57,73.42,60Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.86,92.8c-.18,2.8-.36,5.69-.55,8.64l8.4.57c.19-3,.39-5.87.57-8.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,58.86l8.89.55c.14-2.06.27-4,.4-5.8a6.66,6.66,0,0,1-2.26-1.21L55,52Q54.84,55.12,54.61,58.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.39,102.06l3.66.25.65-8.72-3.76-.23C144.76,96.18,144.58,99.09,144.39,102.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.06,44.36l-2.13-.16a6.69,6.69,0,0,1-1.72,8.15l3.25.2C73.69,49.26,73.9,46.5,74.06,44.36Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.24,183.08c0,.65-.09,1.28-.13,1.86l8.69.65c0-.6.07-1.25.11-2Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89,185.44c-.06.8-.11,1.55-.17,2.25l8.48.63c0-.73.09-1.51.13-2.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.62,61.77a4.91,4.91,0,0,1,.09-.67l-6.33-.42c-.17,2.74-.35,5.7-.54,8.86l8.61.54c.09-1.38.19-2.72.28-4A5.2,5.2,0,0,1,79.62,61.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,184.86c0,.78-.11,1.48-.16,2.15l8.79.66q0-1,.12-2.25Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.66,186c-.06.84-.12,1.62-.17,2.35l8.79.66c0-.76.08-1.58.13-2.46Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.05,184.3c-.06.73-.11,1.41-.16,2l8.51.64c0-.67.07-1.37.12-2.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.39,183.74l-1.17-.08c-.06.7-.1,1.35-.15,2l9.55.72c0-.64.07-1.33.11-2.05Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.37,69.55c-.17,2.71-.34,5.54-.53,8.5l8.82.55q.3-4.41.57-8.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.89,71.73l3,.19q.31-4.71.6-8.81l-4.2-.27a9.81,9.81,0,0,1,.55,1.13A11,11,0,0,1,106.89,71.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8,70.19q-.26,4-.52,8.45l8.55.54q.3-4.4.57-8.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.58,59.4c-.17,2.78-.35,5.78-.54,9l8.8.54c.22-3.16.42-6.14.61-8.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56,74.31q.33-4.8.62-8.94l-8.6-.54q-.24,4.13-.54,8.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.94,60c-.16,2.76-.34,5.74-.54,8.91l8.88.55c.21-3.15.42-6.11.61-8.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.15,64.19q.25-3.72.48-6.84l-8.37-.52c-.12,2.07-.26,4.34-.4,6.8Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,186.56c-.07.88-.13,1.71-.19,2.46l3,.23.19-2.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.65,88.65q-.27,4.18-.55,8.6l8.5.54q.29-4.4.56-8.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.66,72.5c.22-3.13.42-6.09.61-8.83L111,63.14c-.17,2.74-.34,5.68-.54,8.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.73,73.1c.21-3.15.41-6.11.61-8.85l-8.58-.54c-.16,2.74-.34,5.69-.53,8.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.49,73.69c.22-3.17.42-6.14.61-8.89l-8.28-.52c-.17,2.74-.34,5.7-.54,8.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.76,68.27q-.24,4.13-.53,8.64l8.63.52q.3-4.47.58-8.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,182.44c0,.63-.09,1.22-.13,1.78l9.35.7c0-.58.06-1.21.1-1.86Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.45,83.44c-.18,2.81-.36,5.74-.55,8.75l8.42.57c.2-3,.4-6,.59-8.79Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,74.34c-.17,2.69-.34,5.54-.53,8.49l8.47.58q.3-4.47.58-8.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.24,73.79c-.16,2.69-.34,5.51-.52,8.45l8.15.55c.2-3,.39-5.79.58-8.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56,83.45l3.88.26.64-8.56-4-.25C145.92,77.61,145.74,80.47,145.56,83.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,82.89c-.17,2.8-.36,5.71-.55,8.71l8.12.54c.2-3,.39-5.93.58-8.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.84,65.12l.52-6.92L147.85,58a5.8,5.8,0,0,1-.79.59q-.17,2.88-.36,6.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,74.35l4,.27.68-9-4.14-.25C146.5,68.16,146.32,71.15,146.12,74.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.18,73.22q-.24,4-.52,8.42l8.45.56q.3-4.41.57-8.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.86,76.53A13.21,13.21,0,0,1,86,71.06l-4-.26c-.16,2.68-.34,5.49-.52,8.42l9,.58c.06-.93.12-1.84.18-2.74C90.39,76.89,90.11,76.73,89.86,76.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.51,67.16l-.3-.13a5.09,5.09,0,0,1-2-.65c-.07,1.21-.15,2.46-.23,3.74l3.72.24c0-.13-.1-.26-.14-.39A8.64,8.64,0,0,1,84.51,67.16Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,68.91c-.17,2.73-.34,5.58-.53,8.56l8.76.54c.19-3,.39-5.79.57-8.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.23,77.45c0,.79-.1,1.58-.15,2.39l8.36.54c0-.64.09-1.27.13-1.89A11.41,11.41,0,0,1,91.23,77.45Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,92.81l3.77.25.66-8.82L145.52,84C145.35,86.83,145.16,89.78,145,92.81Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4,72.65c-.16,2.68-.34,5.48-.52,8.41l8.17.54q.28-4.39.57-8.42Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,64.22l8.6.58.42-5.93a6.72,6.72,0,0,1-8.41-1.48H138C137.9,59.45,137.77,61.74,137.62,64.22Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.62,72.41a10.64,10.64,0,0,1-3.42,4.4,10.13,10.13,0,0,1-3,1.51c0,.7-.09,1.39-.13,2.1l.36,0,8.85.58q.3-4.39.57-8.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.85,45.77l-1.56-.12a6.67,6.67,0,0,1-1.49,7.94l2.46.16C92.49,50.55,92.69,47.87,92.85,45.77Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.64,180.56c0,.54-.08,1.07-.11,1.56l9.08.68q0-.77.09-1.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,96q-.27,4.29-.56,8.74l8.55.52q.28-4.41.56-8.66Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44,181.83c0,.6-.08,1.17-.12,1.7l8.89.67c0-.56.06-1.15.09-1.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.8,111.26l3.56.25.65-8.67-3.66-.22C144.17,105.44,144,108.33,143.8,111.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.51,101.5q-.27,4.2-.55,8.56l8.07.54q.28-4.38.56-8.59Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.58,77.33l-10.09-.72-.68,9,10.18.6Q43.29,81.63,43.58,77.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3,52.32a6.7,6.7,0,0,1-2.87-1.25l-7-.5-.53,7.12,10,.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.24,119.94c0,.24,0,.48-.05.72l3.46.24.67-8.86-3.56-.22C143.59,114.49,143.42,117.19,143.24,119.94Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.61,86.73c-.18,2.85-.36,5.79-.55,8.79l8.56.52c.19-3,.39-5.89.58-8.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.45,100.93q-.27,4.18-.55,8.53l8.37.55c.19-2.9.37-5.76.56-8.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.27,102.05q-.27,4.22-.55,8.6l8.38.57q.3-4.41.57-8.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77,151.76,27.91,151l-.64,8.43,11,.64C38.43,157.43,38.6,154.66,38.77,151.76Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.38,142.06l-10.75-.77-.7,9.38c2.91.16,6.58.37,10.87.63C39,148.35,39.18,145.26,39.38,142.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.63,97.26c-.18,2.82-.36,5.68-.55,8.6l8.74.55q.29-4.36.56-8.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4,179.91c0,.53-.07,1-.11,1.52l9,.67c0-.5,0-1,.08-1.56Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06,97.9c-.17,2.8-.36,5.65-.54,8.55L79,107q.29-4.35.56-8.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.26,96.62c-.18,2.84-.36,5.72-.55,8.66l8.67.54c.2-2.92.38-5.79.57-8.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,179.08l-.11,1.48,11.32.85c0-.48.06-1,.09-1.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.24,160.52l-11-.79-.72,9.54c3,.16,6.73.38,11.14.64C37.84,167.06,38,163.92,38.24,160.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07,111.78l-8.39-.52q-.26,4-.52,8.19c0,.2,0,.4,0,.6l8.37.57c0-.25,0-.48,0-.73C142.72,117.15,142.89,114.44,143.07,111.78Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.86,99.14c-.17,2.79-.35,5.62-.54,8.51l8.28.54c.19-2.89.38-5.72.56-8.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.67,100.36q-.27,4.19-.55,8.52l8.09.53c.19-2.9.37-5.74.56-8.53Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.28,112.3c.15-2.42.31-4.8.46-7.16L31.4,104.4l-.68,9.08,10.44.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,114.54l-10.43-.75L30,122.52l10.54.62C40.76,120.32,41,117.45,41.13,114.54Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.23,98.51c-.17,2.79-.36,5.63-.54,8.53l8.94.57c.18-2.89.37-5.73.55-8.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,86.69,32.79,86l-.67,8.92,10.26.6C42.57,92.48,42.77,89.54,43,86.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.16,99.75l-.32,0q-.27,4.17-.54,8.51l9.13.59c.19-2.89.37-5.73.56-8.51Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.22,88c-.18,2.81-.36,5.7-.55,8.65l8.75.55c.2-2.94.39-5.82.57-8.61Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,111.21l-8.07-.5q-.26,3.89-.51,7.89l-.06.86,8.07.54,0-.6C133.64,116.63,133.81,113.9,134,111.21Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.35,95.93c-4-.28-7.46-.52-10.26-.73l-.66,8.88,10.34.6Q42.07,100.23,42.35,95.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.85,87.37c-.18,2.83-.36,5.74-.55,8.71l8.69.53c.19-3,.38-5.84.57-8.64Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,68.23c-3.89-.27-7.26-.51-10-.72l-.66,8.77,10.1.59C43.82,73.86,44,71,44.2,68.23Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,181.2c0,.57-.09,1.11-.13,1.62l9.16.69c0-.54.06-1.1.09-1.7Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.55,123.6c-4.1-.29-7.64-.54-10.53-.76l-.69,9.23,10.64.62Q40.25,128.25,40.55,123.6Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.94,133.15c-4.18-.3-7.77-.55-10.64-.77L28.66,141l10.75.62C39.58,138.86,39.76,136,39.94,133.15Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85,58.73c-3.86-.27-7.21-.51-10-.72l-.69,9.18c2.77.15,6.15.35,10,.58C44.45,64.55,44.66,61.53,44.85,58.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44,105.19l-.7,0c-.15,2.36-.31,4.74-.46,7.16l-.12,1.78.7,0,.12-1.78C42.13,109.93,42.29,107.55,42.44,105.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.24,160.52c-.21,3.4-.4,6.54-.57,9.39l.45,0c.2-2.85.42-6,.65-9.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.85,58.73c-.19,2.8-.4,5.82-.62,9l.56,0c.2-3.22.38-6.25.55-9.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.35,95.93q-.29,4.29-.58,8.75l.7,0q.28-4.45.56-8.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,68.23c-.19,2.75-.38,5.63-.59,8.64l.62,0q.29-4.51.53-8.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.94,133.15c-.18,2.89-.36,5.71-.53,8.44l.64,0c.18-2.73.37-5.55.56-8.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.38,142.06c-.2,3.2-.39,6.29-.58,9.24l.6,0c.2-3,.41-6,.62-9.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.64,170.37c-.2,3.51-.38,6.55-.52,9.07l.32,0c.18-2.52.4-5.55.65-9.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.55,123.6q-.3,4.65-.58,9.09l.67,0q.3-4.44.6-9.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4,179.91l-.3,0c0,.53-.06,1-.09,1.52l.28,0C37.33,181,37.37,180.44,37.4,179.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,86.69c-.19,2.85-.39,5.79-.58,8.79l.68,0c.19-3,.37-5.94.55-8.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.13,114.54c-.18,2.91-.37,5.78-.55,8.6l.69,0c.19-2.82.37-5.68.56-8.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77,151.76c-.17,2.9-.34,5.67-.5,8.29l.54,0q.25-3.93.56-8.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.58,77.33q-.28,4.29-.59,8.9l.65,0c.2-3.06.38-6,.56-8.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.37,58.3c.13-2.1.24-4.07.35-5.9l-.42-.08-.42,6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.82,78q-.28,4.26-.59,8.81l.66,0q.28-4.54.55-8.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.09,59.37q-.29,4.17-.62,9l.57,0c.19-3.19.37-6.19.54-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.79,124.24q-.3,4.61-.58,9l.68,0q.28-4.39.59-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.62,142.7c-.2,3.17-.39,6.23-.57,9.16l.59,0c.2-2.93.41-6,.62-9.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.65,51.38l.4,0c.2-3.39.36-6.23.48-8.44h-.26C55.1,45.14,54.89,48,54.65,51.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2,87.33c-.19,2.82-.39,5.73-.58,8.71l.68,0c.19-3,.37-5.88.55-8.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.18,133.79q-.27,4.29-.53,8.36l.65,0c.18-2.7.36-5.5.55-8.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.68,105.83l-.7,0q-.23,3.57-.47,7.21c0,.55-.07,1.1-.1,1.65l.69,0c0-.56.07-1.1.11-1.66C51.37,110.6,51.52,108.2,51.68,105.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.61,51.92c-.15,2.11-.31,4.42-.48,6.91l.48,0q.22-3.75.41-6.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.58,96.58q-.27,4.24-.56,8.66l.69,0c.19-2.94.37-5.82.55-8.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.47,161.16c-.2,3.37-.39,6.48-.56,9.31l.45,0c.2-2.83.42-5.94.65-9.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.37,115.18q-.28,4.32-.55,8.52l.69,0c.19-2.79.37-5.63.56-8.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.88,171c-.2,3.47-.38,6.48-.52,9l.32,0c.19-2.51.4-5.51.65-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.64,180.56l-.31,0c0,.54-.06,1.06-.08,1.56l.28,0C46.56,181.63,46.6,181.1,46.64,180.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,152.4c-.18,2.87-.34,5.61-.5,8.21l.54,0c.18-2.59.36-5.33.56-8.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.44,68.87q-.28,4.09-.58,8.56l.61,0c.19-3,.36-5.83.53-8.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.68,172.29c-.2,3.41-.37,6.38-.51,8.88l.32,0c.18-2.49.4-5.46.64-8.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.23,70.15q-.27,4-.57,8.45l.62,0q.27-4.41.52-8.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.38,97.85q-.27,4.2-.56,8.56l.7,0c.18-2.9.37-5.75.54-8.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.17,116.46c-.18,2.84-.37,5.65-.54,8.41l.69,0q.27-4.14.55-8.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62,79.25C71.43,82.05,71.24,85,71,88l.65,0c.19-3,.37-5.91.55-8.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.81,153.67c-.18,2.84-.34,5.54-.5,8.11l.54,0c.18-2.57.36-5.27.56-8.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.89,60.64c-.19,2.75-.4,5.71-.61,8.86l.56,0c.19-3.16.37-6.12.54-8.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.27,162.43c-.2,3.33-.39,6.4-.55,9.21l.45,0q.3-4.21.64-9.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.47,107.1l-.69,0q-.24,3.61-.48,7.34l-.09,1.41.7,0,.09-1.42Q70.24,110.74,70.47,107.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.44,181.83l-.31,0c0,.6-.06,1.16-.09,1.7l.28,0C65.36,183,65.4,182.43,65.44,181.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,144q-.3,4.71-.57,9.06l.6,0q.3-4.35.61-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68,135.07c-.18,2.82-.36,5.58-.52,8.25l.64,0c.18-2.67.36-5.43.55-8.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.46,52.55l.4,0c.19-3.29.34-6,.46-8.2h-.26C73.9,46.5,73.69,49.26,73.46,52.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71,88.6c-.18,2.79-.37,5.67-.57,8.61l.68,0q.29-4.41.55-8.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,53.19q-.22,3.12-.48,6.81l.49,0c.14-2.46.28-4.73.4-6.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.59,125.51q-.3,4.56-.57,8.91l.67,0q.28-4.35.59-8.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.48,173.53c-.2,3.38-.37,6.35-.51,8.84l.33,0c.18-2.49.39-5.45.63-8.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.26,53.75l.4,0c.18-3.2.33-5.88.45-8h-.26C92.69,47.87,92.49,50.55,92.26,53.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.39,126.76c-.2,3-.38,6-.57,8.86l.68,0q.28-4.33.58-8.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.61,154.92c-.17,2.82-.34,5.5-.5,8.06l.55,0c.17-2.56.36-5.24.55-8.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,117.7q-.27,4.24-.54,8.37l.69,0q.27-4.11.55-8.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.18,99.1c-.18,2.78-.37,5.62-.55,8.51l.69,0c.19-2.89.37-5.72.54-8.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.42,80.49q-.28,4.19-.58,8.66l.65,0q.29-4.49.55-8.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.22,145.22q-.3,4.68-.57,9l.6,0q.3-4.34.61-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.07,163.68c-.2,3.3-.38,6.36-.55,9.16l.46,0q.28-4.2.63-9.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.65,77.06c-.06.9-.12,1.81-.18,2.74l.61,0c0-.81.1-1.6.15-2.39C91,77.33,90.84,77.19,90.65,77.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62,54.47l-.41,0c0,.8-.11,1.62-.17,2.47l.44,0C92.53,56,92.57,55.24,92.62,54.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.78,136.31q-.27,4.22-.52,8.21l.64,0q.27-4,.55-8.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.27,108.35l-.69,0q-.24,3.7-.49,7.51c0,.4,0,.8-.08,1.2l.7,0c0-.41.05-.8.08-1.21C89,113.32,89.12,110.82,89.27,108.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.24,183.08l-.31,0c0,.65-.07,1.28-.1,1.86l.28,0C84.15,184.36,84.2,183.73,84.24,183.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.79,89.85c-.18,2.77-.37,5.63-.56,8.55l.68,0c.18-2.92.37-5.78.54-8.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.84,72.62q-.27,4-.57,8.4l.61,0c.18-2.93.36-5.73.52-8.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.41,156.14c-.17,2.82-.34,5.51-.49,8.07l.54,0c.18-2.56.36-5.24.55-8.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.22,81.71c-.18,2.79-.38,5.68-.58,8.67l.66,0c.18-3,.36-5.88.54-8.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.05,184.3l-.32,0c0,.72-.08,1.41-.11,2.05l.27,0C102.94,185.71,103,185,103.05,184.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.07,55l.39,0c.18-3.13.33-5.74.44-7.81h-.26C111.48,49.24,111.29,51.85,111.07,55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.6,91.07c-.19,2.78-.38,5.64-.57,8.56l.68,0c.19-2.92.37-5.78.54-8.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.58,137.53q-.27,4.22-.52,8.22l.65,0c.17-2.67.36-5.41.54-8.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,100.32c-.19,2.78-.37,5.62-.56,8.51l.69,0q.28-4.34.55-8.52Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.42,55.69l-.4,0c-.15,2.06-.31,4.32-.48,6.76l.48,0C111.17,60,111.3,57.75,111.42,55.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,146.44q-.3,4.68-.57,9l.61,0q.28-4.34.6-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,72c.2-3.14.37-6.08.54-8.82l-.49,0q-.28,4.1-.6,8.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.19,128q-.28,4.53-.57,8.86l.68,0c.19-2.88.38-5.84.58-8.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.28,174.75c-.2,3.37-.37,6.34-.51,8.84l.33,0c.18-2.49.39-5.46.63-8.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.87,164.9c-.2,3.3-.38,6.36-.55,9.16l.46,0q.3-4.2.63-9.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.08,109.57l-.7,0q-.24,3.8-.5,7.7l-.06,1,.69,0c0-.34,0-.68.07-1C107.75,114.67,107.91,112.1,108.08,109.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.77,118.93q-.27,4.23-.54,8.36l.69,0c.18-2.74.37-5.53.55-8.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.12,175.89c-.2,3.38-.37,6.37-.51,8.87l.33,0c.18-2.51.4-5.49.63-8.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.25,157.28q-.25,4.25-.5,8.11l.55,0q.27-3.85.55-8.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.83,101.46c-.19,2.79-.37,5.65-.56,8.55l.69,0q.29-4.36.55-8.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.92,110.71l-.7,0q-.25,3.9-.51,7.9l-.06.85.7,0,.06-.86Q125.67,114.6,125.92,110.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.06,82.85c-.18,2.8-.38,5.71-.58,8.71l.65,0c.19-3,.38-5.91.55-8.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.89,185.44l-.32,0q-.07,1.2-.12,2.25l.27,0C120.78,187,120.83,186.24,120.89,185.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.68,73.75q-.27,4-.57,8.45l.61,0c.18-2.94.36-5.76.52-8.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.61,120.06q-.27,4.27-.54,8.41l.69,0c.18-2.75.37-5.56.55-8.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,129.12q-.28,4.55-.57,8.9l.68,0q.28-4.35.58-8.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.26,56.83l-.4,0q-.23,3.11-.48,6.8l.48,0C129,61.17,129.14,58.9,129.26,56.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.3,56.18l0-.55c-.13.17-.28.31-.42.47v0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.71,166c-.2,3.31-.38,6.39-.55,9.2l.46,0q.3-4.22.64-9.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.28,73.14c.2-3.16.37-6.12.54-8.86l-.48,0c-.2,2.74-.4,5.7-.61,8.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.86,147.58q-.3,4.69-.57,9l.61,0q.28-4.35.6-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.42,138.67c-.18,2.82-.35,5.58-.52,8.26l.65,0c.17-2.68.36-5.43.54-8.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44,92.21q-.28,4.19-.57,8.6l.68,0q.28-4.41.54-8.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,130.23q-.28,4.59-.57,9l.67.05q.3-4.4.6-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.46,121.18c-.19,2.87-.37,5.71-.55,8.49l.69.05q.27-4.18.56-8.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28,93.32c-.18,2.82-.38,5.72-.57,8.69l.68,0c.19-3,.37-5.88.55-8.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,177c-.2,3.41-.37,6.42-.52,9l.34,0c.18-2.53.4-5.55.64-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.7,64.84q.2-3.37.36-6.26a3.93,3.93,0,0,1-.42.29l-.42,5.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.74,186.56l-.33,0c0,.88-.09,1.7-.13,2.46l.27,0C138.61,188.27,138.67,187.44,138.74,186.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.26,139.79q-.27,4.28-.52,8.34l.64.05c.18-2.71.37-5.5.56-8.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.56,167.15c-.21,3.35-.39,6.45-.56,9.3l.46,0c.2-2.84.41-5.95.64-9.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.67,102.57q-.27,4.25-.57,8.65l.7,0c.19-2.93.37-5.82.55-8.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,158.4q-.27,4.29-.51,8.19l.55,0c.18-2.6.36-5.33.56-8.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.7,148.69q-.3,4.74-.57,9.14l.6,0q.3-4.4.62-9.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,74.35c.2-3.2.38-6.19.54-8.95l-.48,0q-.28,4.14-.62,8.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,74.87q-.28,4.06-.58,8.54l.61,0c.18-3,.36-5.84.53-8.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.91,84c-.19,2.82-.39,5.76-.59,8.79l.65,0c.19-3,.38-6,.55-8.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.76,111.82l-.69,0c-.18,2.66-.35,5.37-.53,8.11,0,.25,0,.48,0,.73l.7,0c0-.24,0-.48.05-.72C143.42,117.19,143.59,114.49,143.76,111.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.45,60c-.19,2.76-.39,5.74-.61,8.9l.56,0c.2-3.17.38-6.15.54-8.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.25,171.65q-.31,5.17-.52,8.93l.32,0c.18-2.49.4-5.48.64-8.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.38,153q-.27,4.28-.5,8.15l.54,0c.17-2.57.36-5.29.55-8.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.15,124.88q-.28,4.58-.57,9l.67,0c.2-2.92.39-5.9.59-8.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.18,78.61c-.18,2.82-.38,5.74-.58,8.75l.65,0c.19-3,.38-5.93.55-8.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58,143.34c-.2,3.15-.39,6.19-.57,9.1l.6,0c.2-2.9.4-5.94.61-9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,69.51c-.18,2.71-.38,5.54-.57,8.5l.61,0c.19-3,.36-5.79.53-8.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56,181.2l-.31,0q0,.85-.09,1.62l.27,0C55.92,182.31,56,181.77,56,181.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,106.47l-.69,0q-.24,3.49-.46,7.08l-.12,1.72.7,0c0-.57.08-1.14.11-1.71Q60.82,110,61,106.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.54,134.43q-.27,4.26-.52,8.3l.64,0c.18-2.68.37-5.46.55-8.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61,97.22c-.19,2.81-.37,5.68-.57,8.6l.7,0c.19-2.92.37-5.78.55-8.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.74,115.82q-.29,4.29-.55,8.45l.69,0c.18-2.77.37-5.59.55-8.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,88c-.19,2.8-.38,5.69-.57,8.64l.68,0c.19-3,.37-5.84.55-8.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,59.44c.12-2,.24-3.95.34-5.72l-.42-.11c-.13,1.8-.26,3.74-.4,5.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.84,161.8c-.2,3.34-.39,6.43-.56,9.25l.45,0c.2-2.81.42-5.9.64-9.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.16,89.21q-.27,4.19-.56,8.58l.68,0c.18-2.92.37-5.79.54-8.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.59,144.58q-.3,4.69-.57,9l.6,0q.3-4.34.61-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.44,163c-.2,3.32-.38,6.39-.55,9.18l.45,0c.2-2.79.41-5.86.64-9.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.61,182.44l-.31,0c0,.63-.06,1.22-.09,1.78l.27,0C74.52,183.66,74.56,183.07,74.61,182.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4,70.76q-.27,4-.57,8.42l.62,0c.18-2.93.36-5.74.52-8.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.76,126.12q-.3,4.55-.57,8.88l.67,0q.28-4.33.59-8.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.34,117.07c-.18,2.83-.36,5.63-.54,8.38l.69,0c.18-2.74.36-5.54.55-8.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.79,79.86c-.19,2.79-.38,5.69-.58,8.68l.65,0q.28-4.48.55-8.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.85,172.9c-.2,3.41-.37,6.37-.51,8.85l.32,0c.18-2.47.39-5.43.63-8.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.64,107.71l-.69,0c-.15,2.32-.3,4.66-.46,7,0,.56-.07,1.12-.11,1.68l.7,0c0-.56.07-1.12.11-1.69C79.34,112.38,79.5,110,79.64,107.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.15,135.68c-.18,2.81-.35,5.56-.52,8.23l.64,0c.18-2.67.36-5.42.55-8.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8,57.09c0-.74.09-1.46.13-2.16l-.42-.16c-.06.82-.12,1.68-.18,2.57A4.23,4.23,0,0,1,82.8,57.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.55,98.46q-.27,4.19-.56,8.53l.7.05c.18-2.9.37-5.74.54-8.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,154.29c-.17,2.82-.34,5.52-.5,8.08l.55,0c.17-2.56.35-5.26.55-8.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,66.05c-.09,1.31-.19,2.65-.28,4l.56,0c.08-1.28.16-2.53.23-3.74A3.42,3.42,0,0,1,81.73,66.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.22,183.66l-.31,0c0,.7-.07,1.35-.11,2l.27,0C93.12,185,93.16,184.36,93.22,183.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,136.9c-.17,2.8-.35,5.55-.51,8.2h.14l.5,0c.18-2.66.36-5.41.54-8.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.77,90.43c-.18,2.78-.37,5.64-.57,8.56l.68,0c.19-2.92.37-5.78.55-8.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,118.29q-.28,4.24-.54,8.36l.35,0,.34,0q.27-4.11.54-8.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.57,78.49c0,.62-.09,1.25-.13,1.89l.62,0c0-.71.08-1.4.13-2.1C100,78.39,99.78,78.43,99.57,78.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.16,99.68c-.18,2.79-.37,5.62-.56,8.51l.55,0h.15q.27-4.33.54-8.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.41,58.27c0-.75.09-1.48.13-2.18-.15-.08-.27-.18-.41-.27,0,.73-.11,1.48-.16,2.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.39,81.08c-.18,2.79-.38,5.67-.57,8.65l.65,0c.19-3,.37-5.87.54-8.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.72,127.37l-.36,0q-.28,4.53-.56,8.86l.67,0c.19-2.88.39-5.83.58-8.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.33,145.81h-.14c-.19,3.12-.38,6.13-.56,9l.6,0c.19-2.88.4-5.89.6-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.25,108.93H98.1l-.54,0q-.24,3.47-.46,7c0,.56-.07,1.12-.11,1.68l.7,0c0-.56.07-1.12.11-1.68Q98,112.41,98.25,108.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.46,174.12c-.2,3.4-.37,6.36-.51,8.83l.32,0c.18-2.47.39-5.42.63-8.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.05,164.26c-.2,3.31-.39,6.37-.55,9.16l.45,0c.2-2.79.41-5.85.63-9.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.59,155.51c-.18,2.81-.34,5.5-.5,8.05l.54,0c.18-2.55.36-5.24.55-8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.86,110.13l-.7,0q-.22,3.47-.45,7c0,.56-.08,1.12-.11,1.69l.69,0c0-.57.08-1.13.11-1.7Q116.64,113.61,116.86,110.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.62,73.18q-.28,4-.57,8.42l.61,0q.28-4.4.52-8.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,82.28c-.19,2.79-.38,5.69-.58,8.67l.66,0c.19-3,.37-5.89.54-8.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,128.54c-.19,3-.38,6-.57,8.88l.68,0q.28-4.34.58-8.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.55,119.49c-.18,2.83-.36,5.63-.54,8.38l.69,0c.18-2.75.37-5.54.55-8.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.8,147c-.2,3.12-.38,6.14-.56,9l.59,0c.2-2.89.4-5.91.61-9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.38,91.63q-.28,4.19-.57,8.57l.68,0q.29-4.4.54-8.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.82,184.86l-.3,0c0,.78-.08,1.48-.12,2.15l.26,0C111.71,186.34,111.77,185.64,111.82,184.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.06,175.32c-.2,3.41-.37,6.37-.51,8.84l.32,0c.19-2.47.4-5.42.64-8.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.19,156.71c-.17,2.82-.34,5.52-.49,8.07l.54,0c.17-2.56.36-5.26.55-8.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.77,100.88c-.19,2.79-.37,5.63-.56,8.53l.69,0q.28-4.35.55-8.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.36,138.1c-.18,2.81-.35,5.56-.52,8.22l.65.05c.17-2.67.36-5.42.54-8.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.23,72.54c.19-3.14.37-6.09.53-8.83l-.49,0c-.19,2.74-.39,5.7-.61,8.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.8,63c.13-2.12.25-4.12.36-6-.14-.09-.28-.17-.41-.27-.13,1.91-.28,4-.43,6.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.66,165.46q-.31,5-.55,9.18l.45,0c.19-2.79.4-5.86.63-9.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.89,176.44c-.21,3.39-.38,6.38-.52,8.91l.34,0c.18-2.53.39-5.52.63-8.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,120.62c-.19,2.85-.37,5.67-.54,8.44l.69,0q.27-4.16.55-8.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.77,56.74l-.09-.13v.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,166.59c-.2,3.32-.39,6.41-.56,9.24l.46,0c.2-2.83.42-5.92.64-9.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.83,83.41c-.19,2.8-.38,5.73-.58,8.73l.65,0c.19-3,.37-5.94.55-8.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.45,74.31c-.19,2.69-.38,5.53-.58,8.48l.61,0c.19-3,.36-5.8.53-8.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,111.26l-.69-.05c-.18,2.69-.35,5.42-.53,8.19l0,.6.7,0c0-.2,0-.4,0-.6Q134.43,115.3,134.68,111.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.62,148.13q-.28,4.71-.56,9.09l.6,0q.3-4.38.61-9.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.21,92.76q-.28,4.2-.58,8.63l.68,0c.19-3,.37-5.84.55-8.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.59,102q-.27,4.21-.56,8.59l.69.05q.28-4.38.55-8.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.19,139.22c-.18,2.84-.36,5.6-.53,8.3l.65,0c.18-2.69.36-5.46.55-8.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.33,186c0,.84-.09,1.62-.13,2.35l.29,0c0-.73.11-1.51.17-2.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,73.73q.3-4.77.54-8.9l-.48,0c-.19,2.75-.39,5.72-.61,8.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.62,64.22c.15-2.48.28-4.77.4-6.84l-.39,0q-.23,3.12-.48,6.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,129.67q-.3,4.56-.57,8.94l.67,0c.19-2.91.39-5.9.59-8.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131,157.83c-.18,2.85-.35,5.56-.5,8.15l.55,0c.17-2.58.36-5.3.55-8.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.09,170.4l8.79.61.45,0,8.92.61.44,0,9,.61.45,0,8.72.58.44,0,9.19.6.45,0,8.53.56.44,0,.43,0,9,.58.45,0,8.33.54.45,0,8.61.54.45,0,8.32.52.45,0L139,177l.46,0,3,.18.05-.54-3-.2-.46,0-8.62-.59-.46,0-8.3-.56-.46,0-8.6-.57-.45,0-8.33-.55-.46,0-8.95-.58-.42,0-.45,0L85,172.87l-.46,0-9.18-.59-.45,0-8.72-.55-.45,0-9-.56-.45,0-8.92-.55-.45,0-8.79-.53-.45,0c-4.41-.26-8.18-.48-11.14-.64l0,.3,11.13.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1,179.89l.3,0,8.93.63.31,0,9.06.62.31,0,9.12.61.31,0,8.86.59.31,0,9.32.62.31,0,8.67.56.31,0,1.17.08,8.34.54.32,0,8.47.54.3,0,8.75.56.32,0,8.44.53.33,0,8.75.55.33,0,3,.18,0-.54-3-.21-.34,0-8.73-.59-.34,0-8.43-.56-.33,0-8.74-.58-.32,0-8.45-.55-.33,0L94.44,183,93.27,183,93,183l-8.65-.56-.33,0-9.31-.6-.32,0-8.85-.56-.32,0-9.12-.57-.32,0-9-.56-.32,0-8.92-.54-.32,0-11.3-.65,0,.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.37,151.8l8.64.6.6,0,8.77.6.59,0,8.84.59.6,0,8.57.58.6,0,9,.6.6,0,8.38.55.59,0,.36,0,8.87.57.6,0,8.18.53.6,0,8.46.54.6,0,8.17.51.6,0,8.48.53.6,0,3.12.19,0-.53-3.13-.22-.6,0-8.47-.57-.6,0-8.16-.55-.61,0-8.46-.56-.59,0-8.18-.54-.61,0-8.87-.58-.35,0-.6,0-8.38-.54-.6,0-9-.58-.6,0-8.57-.54-.6,0L58,152.47l-.6,0-8.77-.54-.59,0-8.65-.52-.6,0c-4.29-.26-8-.47-10.87-.63l0,.31,10.86.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.61,133.2l8.57.59.67.05,8.69.59.67,0,8.77.59.67,0,8.5.57.67,0,9,.59.67,0,8.3.55.67,0,.32,0,8.84.57.67.05,8.11.52.67,0,8.39.53.67.05,8.1.5.67.05,8.4.52.68,0,3.28.2,0-.53-3.29-.23-.67-.05-8.4-.57-.67,0-8.09-.55-.68,0-8.38-.56-.68,0-8.1-.54-.68,0-8.83-.58-.32,0-.67,0-8.3-.54-.68,0-9-.58-.67,0-8.5-.54-.67,0-8.77-.55-.67,0-8.69-.54-.68,0-8.57-.52-.67,0-10.64-.62,0,.31c2.87.22,6.46.47,10.64.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.83,114.59l8.54.59.7,0,8.67.59.69.05,8.74.59.7,0,8.47.57.7,0,8.93.59.7,0,8.28.54.69,0,.31,0,8.82.58.7,0,8.08.52.7,0,8.36.53.7,0,8.07.51.7,0,8.38.52.7,0,3.45.21,0-.53-3.46-.24-.7,0-8.37-.57-.7,0-8.07-.54-.7,0-8.36-.55-.69,0-8.09-.53-.69,0L98,117.66l-.31,0-.7,0-8.28-.53-.7,0-8.93-.57-.7,0-8.47-.53-.7,0-8.74-.55-.7,0-8.67-.53-.69,0-8.55-.52-.7,0-10.44-.6,0,.31,10.43.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,96l8.55.6.68,0,8.69.6.68,0,8.75.59.68.05,8.49.56.68.05,9,.59.68,0,8.3.54.68,0,.32,0,8.83.57.68,0,8.1.52.68.05,8.38.53.68,0,8.08.51.68,0,8.4.52.68.05,3.66.22,0-.53-3.66-.25-.68,0-8.4-.57-.68,0-8.08-.54-.68,0-8.38-.56-.68,0-8.1-.53-.68,0-8.82-.58-.33,0-.68,0-8.29-.54-.68,0-9-.57-.68,0-8.5-.54-.68,0-8.75-.55-.68,0-8.69-.53-.68,0-8.56-.52-.68,0-10.26-.6,0,.32c2.8.21,6.25.45,10.26.73Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2,77.37l8.62.6.62,0,8.74.6.62,0,8.82.6.62,0,8.55.57.62,0,9,.59.62,0,8.35.55.62,0,.36,0,8.85.57.62,0,8.16.53.62,0,8.44.53.62,0,8.15.52.62,0,8.46.53.61,0,3.88.23,0-.53-3.88-.26-.61,0-8.47-.58-.61,0-8.15-.55-.61,0-8.45-.56-.61,0-8.17-.54-.61,0-8.85-.58-.36,0-.62,0-8.36-.54-.61,0-9-.58-.62,0-8.55-.54-.62,0-8.82-.55-.61,0-8.76-.54-.61,0-8.63-.52-.62,0-10.1-.59,0,.33,10.09.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34,58.76l8.75.61.49,0,8.87.61.49,0,9,.6.49,0,6.33.42a4.54,4.54,0,0,1,.14-.66L73.42,60l-.49,0-9-.56-.48,0-8.89-.55-.48,0-8.76-.53-.49,0-10-.58,0,.32c2.76.21,6.11.45,10,.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.22,64.8l-8.6-.58-.47,0-8.29-.56-.48,0L119.8,63l-.48,0-8.3-.55-.48,0-4.69-.31c.16.24.3.48.44.73l4.2.27.49,0,8.29.53.49,0,8.58.54.48,0,8.28.52.48,0,8.6.54.48,0,4.14.25,0-.53-4.14-.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.93,50.61l-6.46-.37,0,.33,7,.5A5.45,5.45,0,0,1,41.93,50.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4,57.67l-3.05-.21a6.26,6.26,0,0,1-.5.53l3.51.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,52l6.62.45a6.55,6.55,0,0,1-.66-.63l-5.93-.37-.4,0-4.13-.25a7.12,7.12,0,0,1-.66.46l4.75.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.82,53.22l7,.47A7.1,7.1,0,0,1,80.1,53l-6.24-.4-.4,0-3.25-.2a7.07,7.07,0,0,1-.82.58l4,.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.62,54.47,100,55a6.87,6.87,0,0,1-.68-.75l-6.65-.43-.4,0-2.46-.16a7.33,7.33,0,0,1-.83.64l3.24.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.42,55.69l7.7.49a6,6,0,0,1-.59-.72L111.46,55l-.39,0-1.73-.11a7.89,7.89,0,0,1-.76.65l2.44.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.26,56.83l8.37.52.39,0h.21a7.59,7.59,0,0,1-.46-.65h-.1l-8.37-.56-.39,0h0a7.41,7.41,0,0,1-.64.61l.64,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.76,68.27l8.68.6.56,0,8.8.6.57,0,8.86.6.57,0,8.6.57.57,0,4,.26c-.09-.23-.19-.47-.27-.7L82,70.12l-.56,0-8.61-.54-.56,0L63.4,69l-.56,0L54,68.37l-.57,0-8.68-.52-.56,0c-3.89-.23-7.27-.43-10-.58l0,.32c2.77.21,6.14.45,10,.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.56,74.31,137,73.73l-.55,0-8.21-.55-.55,0-8.5-.56-.57,0L110.44,72l-.55,0-3-.19c-.08.23-.17.45-.27.68l3.22.21.56,0,8.22.53.56,0,8.5.53.56,0,8.21.52.56,0,8.52.53.56,0,4,.25,0-.53-4-.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.61,86.73l8.59.6.65,0,8.71.6.66,0L71,88.6l.66.05,8.51.56.66.05,9,.59.66,0,8.32.54.66,0h.06l9.11.59.65,0,8.13.52.65,0,8.41.54.65,0,8.12.51.65,0,8.42.52.66,0,3.76.23,0-.53L145,92.81l-.65,0-8.42-.57-.65,0-8.12-.54-.65,0-8.4-.56-.66,0-8.12-.53-.66,0-9.11-.6h-.06l-.65,0-8.33-.53-.65,0-9-.57-.65,0L71.69,88,71,88l-8.79-.56-.65,0-8.71-.54-.66,0-8.59-.52-.65,0-10.18-.6,0,.33L43,86.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.44,105.19l8.54.59.7,0,8.67.59.69,0,8.74.59.69,0,8.48.57.69,0,8.94.59.69,0,8.29.54.54,0h.15l9.13.59.7,0,8.08.52.7,0,8.36.53.7,0,8.07.5.69.05,8.39.52.69,0,3.56.22,0-.53-3.56-.25-.7,0-8.38-.57-.69-.05-8.07-.54-.69,0-8.37-.55-.69,0-8.09-.53-.69,0-9.13-.59h-.15l-.55,0-8.28-.54-.69,0L79.69,107,79,107l-8.47-.54-.7,0-8.74-.55-.7,0-8.67-.54-.69,0-8.55-.52-.7,0-10.34-.6,0,.32,10.34.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.24,123.65l8.55.59.69.05,8.67.59.69.05,8.75.58.69,0,8.48.56.69,0,8.94.59.69,0,8.28.54.36,0,.33,0,9.14.59.69,0,8.09.52.69.05,8.37.53.69,0,8.08.51.69,0,8.38.52.7.05,3.36.2,0-.53-3.37-.23-.69-.05-8.38-.57-.69,0-8.08-.55-.69,0-8.37-.56-.69,0-8.09-.54-.69,0-9.13-.6-.34,0-.35,0-8.29-.54-.69,0-8.94-.58-.69,0-8.48-.54-.69,0-8.75-.55-.69,0-8.68-.53-.69,0c-3-.19-5.91-.37-8.55-.52l-.69,0L30,122.52l0,.32c2.89.22,6.43.47,10.53.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,142.1l8.6.6.64,0,8.72.6.64,0,8.8.59.64.05,8.53.56.64,0,9,.6.64,0,8.33.54h.14l.5,0,9.19.6.64,0,8.14.52.64,0,8.42.54.64,0,8.12.51.65,0,8.43.52.65,0,3.2.2,0-.53-3.21-.22-.64-.05-8.43-.57-.65,0-8.11-.55-.65,0-8.41-.56-.65-.05-8.13-.53-.65,0-9.18-.6-.5,0h-.14l-8.34-.53-.64,0-9-.57-.64,0-8.53-.55-.64,0-8.8-.55-.64,0-8.72-.54-.65,0-8.6-.52-.64,0L28.66,141l0,.32,10.75.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77,160.56l8.7.6.54,0,8.83.6.53,0,8.9.6.54,0,8.63.57.54,0,9.09.6.54,0,8.34.55h.1l.53,0,9.29.6.54,0,8.25.53.53,0,8.52.54.55,0,8.22.52.54,0,8.54.53.54,0,3.06.19,0-.53-3.06-.21-.55,0-8.52-.58-.55,0-8.22-.56-.55,0-8.51-.57-.54,0-8.24-.54-.54,0-9.29-.61-.54,0H94L85.66,163l-.55,0L76,162.4l-.55,0-8.63-.55-.54,0-8.89-.56-.54,0-8.83-.55-.54,0-8.7-.53-.54,0-11-.64,0,.32,11,.79Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.86,76.53c.25.2.53.36.79.53s.38.27.58.39a11.41,11.41,0,0,0,8.34,1c.21-.06.41-.1.62-.17a10.13,10.13,0,0,0,3-1.51,10.64,10.64,0,0,0,3.42-4.4c.1-.23.19-.45.27-.68a11,11,0,0,0,0-7.76,9.81,9.81,0,0,0-.55-1.13c-.14-.25-.28-.49-.44-.73a11.37,11.37,0,0,0-4.44-3.84l-.44-.19a10.76,10.76,0,0,0-5.51-.89A8.69,8.69,0,1,1,85.59,70c0,.13.09.26.14.39s.18.47.27.7A13.21,13.21,0,0,0,89.86,76.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,59a6.19,6.19,0,0,0,2.6.22c1.64-.24,2.66-1.28,2.8-1.14s-.09.41-.54.82a4.21,4.21,0,0,1-4.44.72,5.47,5.47,0,0,1,.23,4.66,5.18,5.18,0,0,1-3.76,2.92,5,5,0,0,1,1.92,1.29,4.88,4.88,0,0,1,1.22,2.57c.11.72,0,1.17-.1,1.17S89.16,70.5,87.79,69A6.75,6.75,0,0,0,85,67.27a4,4,0,0,1-.53-.11,8.69,8.69,0,1,0,8.72-10.31,6.26,6.26,0,0,0-.75,0l-.44,0a8.78,8.78,0,0,0-3.5,1.2A3.79,3.79,0,0,1,89.5,59Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.73,66.05a3.42,3.42,0,0,0,.51.33,5.09,5.09,0,0,0,2,.65c-.07,0-.11-.07-.1-.09s.79.11,2-.15A5,5,0,0,0,89.51,64a5.38,5.38,0,0,0-.19-4.43c-.54-1.08-1.18-1.54-1.11-1.64h.05A5.18,5.18,0,0,0,85,56.67a5.13,5.13,0,0,0-2.15.42,4.23,4.23,0,0,0-.47.25,5.17,5.17,0,0,0-2.48,3.1,4.54,4.54,0,0,0-.14.66,4.91,4.91,0,0,0-.09.67A5.2,5.2,0,0,0,81.73,66.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.32,59.61A5.38,5.38,0,0,1,89.51,64a5,5,0,0,1-3.45,2.75c-1.16.26-1.93,0-2,.15s0,0,.1.09l.3.13a4,4,0,0,0,.53.11c-.22-.09-.36-.15-.35-.2s.46-.16,1.18,0a4.47,4.47,0,0,1,.52.17,5.18,5.18,0,0,0,3.76-2.92,5.47,5.47,0,0,0-.23-4.66l-.07,0c-.56-.26-.82-.55-.77-.63s.18,0,.42,0a3.79,3.79,0,0,0-1-.93,1.16,1.16,0,0,0-.28-.13h-.05C88.14,58.07,88.78,58.53,89.32,59.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2,60a4.12,4.12,0,0,0,2.16-1c.45-.41.61-.77.54-.82s-1.16.9-2.8,1.14A6.19,6.19,0,0,1,89.5,59c-.24-.06-.39-.09-.42,0s.21.37.77.63l.07,0A4.1,4.1,0,0,0,92.2,60Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.43,72.27c.09,0,.21-.45.1-1.17a4.88,4.88,0,0,0-1.22-2.57,5,5,0,0,0-1.92-1.29,4.47,4.47,0,0,0-.52-.17c-.72-.16-1.17-.09-1.18,0s.13.11.35.2A6.75,6.75,0,0,1,87.79,69C89.16,70.5,89.23,72.29,89.43,72.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453,287.46s-4.79-3.95-12.38,7.72a160.19,160.19,0,0,0-10.72,18.54s-1.93,2.41-3.53.53-3.52-6.92-6.63-6.38-4.62,3.95-4.57,9.14-.23,16.59-.26,17.61-.76,2.43-2.06,1.33-8.37-10.88-12.8-7.24-1.91,18.08-1.66,19.66-.12,2.21-.9,2.52-2.84-3.21-5-5.9-5.07-5.46-7.45-3.14-4.17,12.76,4,30.91l4.36,8.15,9.27.46c19.92-.22,28.64-6.26,29.73-9.39s-2.65-4.64-6-5.43-7.4-1.18-7.45-2,.36-1.43,1.9-1.87,15.71-4.26,17.13-9.81-10.43-7.85-12-8.55-.57-2,.34-2.42,11.11-5.54,15.84-7.69,7.21-4.84,6.36-8-6.21-2.66-8.59-3.31-1-3.43-1-3.43a161,161,0,0,0,12.27-17.54c7.38-11.81,1.61-14.53,1.61-14.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.85,382.41c5.45-8.65,15.39-23.86,23.86-37s16.12-25,21.61-33.59l6.49-10.22,1.77-2.78.47-.72a2.11,2.11,0,0,1,.16-.23l-.14.25-.44.73-1.72,2.81c-1.5,2.43-3.69,5.94-6.42,10.27C432,320.62,424.42,332.5,416,345.6S397.51,373.9,392,382.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.17,315a3,3,0,0,1,.17.65c.09.42.2,1,.33,1.79.27,1.51.57,3.61.87,5.94s.55,4.37.74,5.95c.1.72.17,1.32.24,1.8a2.8,2.8,0,0,1,.06.67,3,3,0,0,1-.17-.65c-.09-.42-.2-1-.33-1.79-.25-1.52-.53-3.62-.82-5.94s-.58-4.37-.79-5.95c-.09-.71-.18-1.32-.24-1.8A2.8,2.8,0,0,1,422.17,315Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.41,332.09c0-.08,4.29-.9,9.61-1.84s9.65-1.64,9.66-1.56-4.29.9-9.61,1.84S425.42,332.17,425.41,332.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.5,351.63a2.69,2.69,0,0,1,.68,0l1.85.2c1.55.17,3.71.39,6.09.55s4.55.23,6.11.27l1.86.05a2.83,2.83,0,0,1,.68.05,3.1,3.1,0,0,1-.68.06c-.44,0-1.07,0-1.86,0-1.57,0-3.74,0-6.13-.19s-4.55-.41-6.1-.63c-.78-.11-1.4-.21-1.84-.29A3.21,3.21,0,0,1,411.5,351.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.18,336.85a2.75,2.75,0,0,1,.3.55l.74,1.55c.61,1.31,1.44,3.14,2.33,5.16s1.69,3.86,2.25,5.19l.66,1.59a2.33,2.33,0,0,1,.2.6,2.21,2.21,0,0,1-.3-.56c-.21-.42-.45-.93-.74-1.55-.61-1.31-1.44-3.13-2.33-5.15s-1.69-3.86-2.26-5.2c-.25-.62-.47-1.15-.65-1.58A2.33,2.33,0,0,1,405.18,336.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.71,352.53a5.29,5.29,0,0,1,.38.71l1,2c.79,1.68,1.87,4,3,6.59s2.22,4.92,3,6.62c.35.81.64,1.49.86,2a6,6,0,0,1,.29.76,4.58,4.58,0,0,1-.39-.71l-.95-2c-.79-1.68-1.87-4-3-6.59s-2.22-4.92-3-6.62l-.87-2A3.85,3.85,0,0,1,390.71,352.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.12,370.71a4.66,4.66,0,0,1,.86,0l2.35.17c2,.14,4.73.33,7.76.45s5.77.16,7.76.18h2.36a5.37,5.37,0,0,1,.86,0,4.7,4.7,0,0,1-.86.08l-2.36.07c-2,0-4.74,0-7.78-.1s-5.77-.33-7.75-.53c-1-.09-1.79-.18-2.35-.26A4.77,4.77,0,0,1,399.12,370.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.7,206.57s-10.35,117.66-6.62,186.34c3.23,59.57,8.92,79.64,8.92,79.64l33.91-.05Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.3,406.11a12.17,12.17,0,0,1,1.35-9.39,21.38,21.38,0,0,1,6.8-6.88c5.23-3.51,12.34-4.9,18.62-5.22-.09,7-5.41,13.11-8.3,16-4.58,4.64-15.66,10.24-18.47,5.45",
    style: {
      fill: "#397E32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101,373.27a10.32,10.32,0,0,1-9.65,3.82,13.7,13.7,0,0,1-9-5.66c-1-1.36-1.79-3.05-1.36-4.68a4.4,4.4,0,0,1,3.37-2.95,8.88,8.88,0,0,1,4.64.41c5.13,1.62,9.81,4.13,12,9.06",
    style: {
      fill: "#397E32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,366a7.57,7.57,0,0,1-1.1.69l-3.06,1.77A36.36,36.36,0,0,1,105,372.9a22.08,22.08,0,0,1-11.6-.58,15,15,0,0,1-3.2-1.54c-.36-.22-.61-.43-.79-.56s-.26-.21-.25-.22a24.71,24.71,0,0,0,4.34,2,23.09,23.09,0,0,0,11.41.44,39.17,39.17,0,0,0,10.71-4.3c1.31-.69,2.38-1.26,3.12-1.63A7,7,0,0,1,120,366Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.37,401.1a2.53,2.53,0,0,1,.38-.42c.31-.28.69-.65,1.17-1.11,1-1,2.51-2.34,4.36-4,3.72-3.37,8.91-8,14.76-12.88s11.24-9.28,15.19-12.36c2-1.55,3.58-2.79,4.71-3.63l1.29-1a3.07,3.07,0,0,1,.48-.31,2.36,2.36,0,0,1-.42.39l-1.24,1-4.62,3.74c-3.89,3.15-9.25,7.53-15.1,12.46s-11.07,9.47-14.83,12.77L80,399.7l-1.22,1.05A3.23,3.23,0,0,1,78.37,401.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.77,377.75a24.18,24.18,0,0,0-4.94,21.53c.5,1.89,1.57,4,3.5,4.25s3.52-1.52,4.45-3.24a20.66,20.66,0,0,0-2.54-22.78",
    style: {
      fill: "#397E32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.8,394.79a6,6,0,0,1-.36-1.17,11.85,11.85,0,0,1-.3-1.4c-.08-.55-.23-1.17-.28-1.87a20.27,20.27,0,0,1-.13-2.3,24,24,0,0,1,.08-2.64,27,27,0,0,1,1.23-5.93,26.63,26.63,0,0,1,2.64-5.46,20.6,20.6,0,0,1,1.56-2.13,19.14,19.14,0,0,1,1.53-1.72,17.56,17.56,0,0,1,1.39-1.3,10,10,0,0,1,1.11-.89,5.51,5.51,0,0,1,1-.68c.07.08-1.37,1.07-3.28,3.09a20.68,20.68,0,0,0-1.47,1.73,25.47,25.47,0,0,0-1.5,2.13,27.1,27.1,0,0,0-2.55,5.38,27.92,27.92,0,0,0-1.25,5.82c-.07.91-.14,1.78-.12,2.6a20.42,20.42,0,0,0,.08,2.27C108.42,393.09,108.89,394.77,108.8,394.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.26,347.71c12.9-17.77,9.14-41.16,1.61-60.76-1.26-3.27-2.1-6.89-4.68-9.25s-6.94-3.07-9.42-.65c-2.06,2-2.14,5.23-2.7,8.07a20.48,20.48,0,0,1-5.2,10.1c-1.73,1.82-4.11,3.4-6.59,3-3.4-.59-5.1-4.42-6.22-7.72L89.82,272c-1.12-3.3-2.27-6.66-4.38-9.43s-5.37-4.89-8.8-4.69-6.69,3.35-6.24,6.8a32,32,0,0,0,1.33,4.13c.38,1.4.26,3.14-.9,4s-2.82.36-4.14-.27c-4.55-2.15-8.33-5.63-12-9.14s-7.23-7.16-11.57-9.71-9.59-4-14.4-2.6-8.82,6-8.41,11,4.74,8.83,9,11.57A77.8,77.8,0,0,0,49.68,283a6.44,6.44,0,0,1,3.51,1.87c1.48,1.95.15,4.85-1.77,6.32-2.17,1.66-4.92,2.33-7.38,3.52s-4.85,3.28-5,6c-.18,3.84,3.85,6.39,7.42,7.74a66.61,66.61,0,0,0,22.35,4.32c2.73.05,5.55-.06,8.09,1s4.74,3.58,4.36,6.3-3.15,4.52-5.85,4.93-5.44-.19-8.18-.26c-5.11-.15-10.85,2.19-12.39,7.1-1,3.23,0,6.86,2.07,9.6a25.55,25.55,0,0,0,7.81,6.41,67,67,0,0,0,33.6,9.65c11.75,0,21.82-2.37,30.93-9.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,353.68c-3.43-7.61-3.84-7.65-10.24-16.63a312.52,312.52,0,0,0-22.69-27.72l-6.32-6.95c-2.08-2.28-4.14-4.54-6.3-6.63a155.36,155.36,0,0,0-13.06-11.28c-4.33-3.39-8.56-6.44-12.54-9.27s-7.75-5.38-11.28-7.57a123.49,123.49,0,0,0-17.41-9.07c-2.13-.9-3.8-1.55-4.95-2l-1.3-.48-.45-.14a2.53,2.53,0,0,0,.43.2l1.28.54c1.12.46,2.78,1.15,4.9,2.09A130.31,130.31,0,0,1,47.42,268c3.5,2.21,7.24,4.78,11.21,7.62s8.17,5.91,12.48,9.3a158.39,158.39,0,0,1,13,11.26c2.14,2.08,4.18,4.32,6.26,6.61l6.32,7a319.37,319.37,0,0,1,22.68,27.62c6.41,8.94,6.84,8.92,10.31,16.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.35,295.79a7.68,7.68,0,0,0-.16-1.52c-.14-1-.4-2.37-.73-4.09-.67-3.43-1.75-8.15-3-13.35s-2.23-9.92-2.84-13.36c-.31-1.72-.55-3.11-.7-4.08a7.68,7.68,0,0,0-.31-1.49,6.51,6.51,0,0,0,.06,1.52c.08,1,.25,2.39.5,4.12.5,3.47,1.45,8.23,2.67,13.43s2.31,9.77,3.15,13.31c.36,1.6.67,3,.92,4A7.38,7.38,0,0,0,84.35,295.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.29,302.51a10.42,10.42,0,0,0,1.75-.38c1.12-.28,2.74-.69,4.76-1.14,4-.92,9.62-2,15.85-2.92s11.91-1.49,16-1.79c2.06-.17,3.73-.26,4.88-.33a10.09,10.09,0,0,0,1.79-.16,8.53,8.53,0,0,0-1.8-.09c-1.16,0-2.84,0-4.9.12-4.14.19-9.85.7-16.1,1.61a156.25,156.25,0,0,0-15.86,3.12c-2,.5-3.61,1-4.72,1.34A9.35,9.35,0,0,0,39.29,302.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,336.45a2.41,2.41,0,0,0,.11-.62c.06-.48.12-1.07.2-1.78.16-1.55.34-3.79.52-6.57.36-5.56.63-13.25.8-21.73s.37-16.18.62-21.73c.13-2.71.24-4.93.32-6.58,0-.72,0-1.31.07-1.79a1.92,1.92,0,0,0,0-.63,2.41,2.41,0,0,0-.11.62c0,.48-.11,1.06-.19,1.78-.16,1.54-.34,3.79-.52,6.57-.37,5.55-.63,13.24-.81,21.74s-.37,16.17-.61,21.72c-.13,2.7-.24,4.93-.32,6.58,0,.72,0,1.31-.07,1.79A2.78,2.78,0,0,0,119.05,336.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.53,337.77a2.78,2.78,0,0,0,.64,0H59l6.69-.13c5.66-.11,13.47-.17,22.11-.23s16.46-.19,22.11-.41c2.83-.11,5.12-.23,6.69-.34l1.82-.14a2.59,2.59,0,0,0,.63-.09,2.89,2.89,0,0,0-.64,0l-1.82,0-6.7.13c-5.65.11-13.47.17-22.1.23s-16.46.18-22.11.41c-2.83.11-5.12.22-6.7.34l-1.81.13A2,2,0,0,0,56.53,337.77Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.46,60.32A5.17,5.17,0,0,0,234,51.55a3.6,3.6,0,1,0-3.37-6.37,4.2,4.2,0,0,0-6.49-4A5,5,0,0,0,216,44.12a4.16,4.16,0,0,0-7.8,1.56c-1.67-.49-3.65-.91-5,.19s-1.33,2.89-1.29,4.52a26.33,26.33,0,0,0,.56,5.75,13.21,13.21,0,0,0,4.82,7.32A7.76,7.76,0,0,0,216.44,65",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.55,67a4.6,4.6,0,1,0-5.88-7c-.5.49-1,1.13-1.68,1.17s-1.2-.47-1.76-.84a4.53,4.53,0,0,0-7,4.31c-2.31-1-5.51-.7-6.68,1.52-1,2,.16,4.57,2.08,5.71a10,10,0,0,0,6.52.82,26,26,0,0,0,14.13-6.88",
    style: {
      fill: "#397E32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.18,67.1c-.05.13-.81-.17-1.37-.95s-.58-1.6-.44-1.62.38.64.87,1.31S219.26,67,219.18,67.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.38,66.52c-.15,0,0-1.14-.41-2.45s-1-2.23-.85-2.33a3.43,3.43,0,0,1,1.36,2.2A3.38,3.38,0,0,1,227.38,66.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.79,65.44c-.15,0,.14-1.15-.12-2.49s-.9-2.27-.78-2.37a4,4,0,0,1,.9,4.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.9,69.92c0,.06-.36.06-.87-.15a3.88,3.88,0,0,1-2.29-3.39c0-.55.12-.88.18-.87a8.53,8.53,0,0,0,.91,2.6C214.68,69.38,216,69.78,215.9,69.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,118.87a7.26,7.26,0,0,0,4.86-8.37,8.73,8.73,0,0,0,1.86-12.59A6.15,6.15,0,0,0,266,87.1a8.33,8.33,0,0,0-9.13-11.19,7.62,7.62,0,0,0-11.81-7.48c-3.74-5.05-12.32-5.36-16.4-.58-4.75-2.9-11.82-.73-14.13,4.33-3.1-2.89-8.51-1.86-11.33,1.31s-3.49,7.73-3.15,12a7,7,0,0,0-1,12.14c-3.92,4.87-2.86,12.94,2.19,16.62A13.86,13.86,0,0,0,208.05,128",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.93,94.41l-1.77-5,31.28-5c9.62-.73,19.7,9.19,20,18.83.36,10.71.37,23.8-1.13,31.74-3,16-15.38,17.65-15.38,17.65l-1,25.19-35.35-1.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.65,113.75a2.07,2.07,0,0,1-2,2,2,2,0,0,1-2.06-1.92,2.06,2.06,0,0,1,2-2A2,2,0,0,1,256.65,113.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,109.9c-.26.26-1.78-.94-4-1s-3.87,1-4.1.72c-.11-.13.16-.6.88-1.1a5.73,5.73,0,0,1,3.3-.91,5.41,5.41,0,0,1,3.17,1.13C258.79,109.29,259,109.79,258.87,109.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.79,112.59a2.06,2.06,0,0,1-2,2,2,2,0,0,1-2.06-1.91,2.06,2.06,0,0,1,2-2A2,2,0,0,1,234.79,112.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.61,109.63c-.26.26-1.79-.94-4-1s-3.87,1-4.1.72c-.12-.12.15-.6.88-1.09a5.62,5.62,0,0,1,3.29-.91,5.44,5.44,0,0,1,3.18,1.13C236.52,109,236.74,109.51,236.61,109.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.65,126.33a14.58,14.58,0,0,1,3.62-.54c.56,0,1.1-.14,1.21-.52a3,3,0,0,0-.33-1.69l-1.55-4.35c-2.14-6.2-3.67-11.29-3.42-11.38s2.19,4.88,4.33,11.07L250,123.3a3.27,3.27,0,0,1,.22,2.23,1.42,1.42,0,0,1-1,.8,3.86,3.86,0,0,1-1,.1A14,14,0,0,1,244.65,126.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246,152.62a42.49,42.49,0,0,1-21.86-6.41s5.09,11.39,21.74,10.41Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.84,98c-.12.63-2.35.7-4.86,1.43s-4.48,1.76-4.91,1.28c-.19-.23.08-.85.82-1.56a5.18,5.18,0,0,1,3.48-1.89,8.38,8.38,0,0,1,4-.17C235.34,97.32,235.89,97.71,235.84,98Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.82,102.93c-.43.47-1.91-.17-3.74-.33s-3.4.07-3.72-.48c-.13-.27.15-.75.86-1.17a5.11,5.11,0,0,1,3.11-.59,5.24,5.24,0,0,1,2.9,1.24C258.84,102.17,259,102.7,258.82,102.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.93,84.1a7.79,7.79,0,0,0,1.88,3.47,2.71,2.71,0,0,0,3.6.21,3.57,3.57,0,0,0,5.53-.38,4.87,4.87,0,0,0,5.87.58l4.78,1c1.73.38,3.89.61,4.95-.81.25-.32.43-.74.8-.91a2.34,2.34,0,0,1,1.23,0,4.13,4.13,0,0,0,3.59-1.69,12.17,12.17,0,0,0,1.78-3.72c.7-2,1.25-4.6-.39-6a5.28,5.28,0,0,0-2.3-.91,12.16,12.16,0,0,0-5-.38,8.89,8.89,0,0,0-5,3.61,2.24,2.24,0,0,0-1.37-2.77,4.41,4.41,0,0,0-3.35.3A8.78,8.78,0,0,0,241.76,79a7.23,7.23,0,0,0-6.47,4,5.3,5.3,0,0,0-4.12-.74,1.87,1.87,0,0,0-1.24.78.84.84,0,0,0,.42,1.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.41,85.06a5.3,5.3,0,0,0,8.11,6.18A4.88,4.88,0,0,0,258,94.39a7.64,7.64,0,0,0,3.92,6.74,6,6,0,0,0-.11,4.38,3.63,3.63,0,0,0,1.81,2.14,4.15,4.15,0,0,0,3.3-.23,5.94,5.94,0,0,0,3.38-3.27,3.41,3.41,0,0,0-1.52-4.15A12.81,12.81,0,0,0,272,95.41a4.09,4.09,0,0,0,.26-3.13,1.8,1.8,0,0,0-2.63-.88,4.72,4.72,0,0,0-5-6.88,3.92,3.92,0,0,0-6.5-2.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.23,83.26c.15-2-1.71-3.59-3.64-3.86a9.89,9.89,0,0,0-5.6,1.35,6.86,6.86,0,0,0-7.6-1.94c-2.59,1-4.25,3.51-6.39,5.3a14,14,0,0,0-3.23,3c-.78,1.25-.76,3.19.51,3.94a5,5,0,0,0-1.43,8.66c.45.35,1,.66,1.18,1.2a2.27,2.27,0,0,1-.14,1.4c-.76,2.15-1.94,4.16-2.4,6.39s0,4.9,1.93,6.15c.5.33,1.12.59,1.35,1.15a1.84,1.84,0,0,1,0,1.16,21.79,21.79,0,0,1-1.62,3.55,5.43,5.43,0,0,0-.6,3.76,2.48,2.48,0,0,0,3,1.79c-.85,2.46-.79,5.39.8,7.44s6.87,3,10,1.08l.29-7.35c-.42-1.29,1.59-8.18.76-9.58,0,0-2.21,4.78,2.76,4,1.61.44,4.71-4.3,4.93-6a4.46,4.46,0,0,0-2.27-4.17,7.53,7.53,0,0,0,1.94-9.46,4,4,0,0,0,.79-7.78,8.27,8.27,0,0,0,5.3-11.11",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.23,84.71s-.24.14-.55.55a4.29,4.29,0,0,0,.4,5.38,4.57,4.57,0,0,0,4.37,1.2l-.4-.4a3.23,3.23,0,1,0,6.32,1.32h-.75a3.24,3.24,0,0,0,2,2.35,3.16,3.16,0,0,0,2.06.11A2.9,2.9,0,0,0,216.29,94a3.3,3.3,0,0,0,0-3.65l-.47.53a8.13,8.13,0,0,0,6.44.55,7.8,7.8,0,0,0,5.15-6.31,2.89,2.89,0,0,0,0-1.19A9.91,9.91,0,0,1,225.88,88a7.41,7.41,0,0,1-3.82,2.83,7.64,7.64,0,0,1-5.9-.59l-1.45-.81,1,1.34a2.58,2.58,0,0,1,0,2.81,2.18,2.18,0,0,1-2.73.82,2.5,2.5,0,0,1-1.56-1.77L211,90.37l-.34,2.28a2.64,2.64,0,0,1-3.21,2,2.69,2.69,0,0,1-1.74-3.08l.15-.56-.55.16a4,4,0,0,1-3.82-.94,3.82,3.82,0,0,1-1.15-2.89A5.17,5.17,0,0,1,201.23,84.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,75.87a2.11,2.11,0,0,1,.17.93,1.12,1.12,0,0,1-.52.86,1.18,1.18,0,0,1-1.28,0l-.65-.45.32.73a3.18,3.18,0,0,1-.78,3.42,3,3,0,0,1-4.15-.22l-.38-.41-.22.51a5.58,5.58,0,0,1-9.27,1.51l-.23-.27-.28.23a9.49,9.49,0,0,1-4.61,2.11,10.2,10.2,0,0,1-4-.09,16.38,16.38,0,0,1-3.42-1.34s.23.27.76.64A8.84,8.84,0,0,0,235,85.17a10.34,10.34,0,0,0,4.26.27,10.06,10.06,0,0,0,5-2.17l-.5,0a6.25,6.25,0,0,0,10.47-1.7l-.6.1a3.56,3.56,0,0,0,5.88-3.87l-.33.28a1.57,1.57,0,0,0,1.73-.08,1.44,1.44,0,0,0,.57-1.15C261.43,76.09,261,75.84,261,75.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.8,66.26c0,.06.34-.14.93-.17a2.89,2.89,0,0,1,2.2.89,3.78,3.78,0,0,1,.75,3.39,9.17,9.17,0,0,1-2.32,3.91l.55.53h0c.38-.39,1.27,0,1.51.48a2.57,2.57,0,0,1-.05,2,9,9,0,0,1-2,3.16,18.79,18.79,0,0,1-2.84,2.14s.37,0,1-.27a8.27,8.27,0,0,0,2.26-1.48,9,9,0,0,0,2.3-3.31,3.18,3.18,0,0,0,.06-2.54A2,2,0,0,0,236,74a1.55,1.55,0,0,0-1.57.26l0,0,.55.53a9.36,9.36,0,0,0,2.44-4.29,4.26,4.26,0,0,0-1.06-3.91,3.08,3.08,0,0,0-2.62-.79C233,65.93,232.78,66.23,232.8,66.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.62,72.07a10.13,10.13,0,0,1,2.82-.68,5.83,5.83,0,0,1,3.06.73,5.9,5.9,0,0,1,2.57,3l.25.65.39-.58A3.35,3.35,0,0,1,221.8,77v.45l.44-.1a4.59,4.59,0,0,1,3.73.88,4.39,4.39,0,0,1,1.6,2.64,6.9,6.9,0,0,1-.18,2.87s.21-.21.4-.7a4.6,4.6,0,0,0,.23-2.25,4.81,4.81,0,0,0-1.66-3,5.18,5.18,0,0,0-4.28-1.1l.44.35a4.05,4.05,0,0,0-7.42-2.21l.64.08a6.33,6.33,0,0,0-3-3.24,6,6,0,0,0-3.38-.64,5.71,5.71,0,0,0-2.15.65C206.81,71.84,206.6,72,206.62,72.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.75,46.62a4.22,4.22,0,0,1,1.47-1.19,2.75,2.75,0,0,1,2.09-.07,2.84,2.84,0,0,1,1.75,2l.33,1.5.25-1.52a4.08,4.08,0,0,1,3-3.17,4,4,0,0,1,4.4,2.21l.15.34.35-.15a3.49,3.49,0,0,1,1.46-.28,3.87,3.87,0,0,1,3.8,2.83,4.11,4.11,0,0,1-1.36,4.11l-.92.69,1.14-.11a3.14,3.14,0,0,1,2.91,1.49,2.94,2.94,0,0,1,.2,2.59,4.17,4.17,0,0,1-1.53,1.85s.25,0,.63-.25A3.36,3.36,0,0,0,228.11,58a3.29,3.29,0,0,0-.1-3,3.64,3.64,0,0,0-3.42-1.86l.23.58a4.77,4.77,0,0,0,1.68-4.8A4.61,4.61,0,0,0,222,45.51a4.49,4.49,0,0,0-1.76.35l.5.2a4.56,4.56,0,0,0-8.68,1.18l.59,0a3.33,3.33,0,0,0-2.17-2.31,3.1,3.1,0,0,0-2.39.21,3,3,0,0,0-1.12,1C206.77,46.43,206.73,46.61,206.75,46.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.35,52.12a4,4,0,0,1,2.31-.68A2.94,2.94,0,0,1,189,52.69,3.16,3.16,0,0,1,189.1,56l-1.3,2.09,1.77-1.72a3,3,0,0,1,3.68-.22,2.92,2.92,0,0,1,.5,4l.63.4a3.14,3.14,0,0,1,5.67,2.71l.58-.12a1.25,1.25,0,0,1,0-1.63,1.64,1.64,0,0,1,1.66-.46,3.45,3.45,0,0,1,2.25,2.7l.58-.2a1.53,1.53,0,0,1,.37-1.63,1.84,1.84,0,0,1,1.49-.6,3.61,3.61,0,0,1,2.48,1.31c1,1.27,1.41,2.19,1.5,2.13a2.11,2.11,0,0,0-.24-.65,8.19,8.19,0,0,0-1-1.7A3.9,3.9,0,0,0,207,60.86a2.42,2.42,0,0,0-1.93.72,2.11,2.11,0,0,0-.52,2.26l.57-.21a5.49,5.49,0,0,0-.82-1.89,3.2,3.2,0,0,0-1.86-1.32,2.3,2.3,0,0,0-2.38.69,2,2,0,0,0,.07,2.63l.37.35.22-.47a3.89,3.89,0,0,0-7-3.36l.63.4A3.5,3.5,0,0,0,189.15,56l.47.37a3.63,3.63,0,0,0-.24-3.94,3.42,3.42,0,0,0-4.55-.76C184.47,51.91,184.34,52.1,184.35,52.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274,129.5s-.24,0-.62-.17a2.13,2.13,0,0,1-1.14-1.24,2.7,2.7,0,0,1,.27-2.56,8.78,8.78,0,0,1,2.69-2.41l-.37-.52a4.59,4.59,0,0,1-4.84.12,4.17,4.17,0,0,1-1.76-5,4.53,4.53,0,0,1,1-1.69,2.48,2.48,0,0,1,1.47-.87c.43,0,.75.56.72,1.07a1.25,1.25,0,0,1-.88,1.11,3.91,3.91,0,0,1-3.13-.41,5.54,5.54,0,0,1-2.14-2,5.71,5.71,0,0,1-.7-4.14c.21-1,.54-1.52.47-1.55a3.14,3.14,0,0,0-.76,1.47,5.79,5.79,0,0,0,.53,4.5,6,6,0,0,0,2.29,2.25,4.53,4.53,0,0,0,3.7.51,2.27,2.27,0,0,0,.91-.63,1.78,1.78,0,0,0,.44-1.11,2,2,0,0,0-.29-1.16,1.42,1.42,0,0,0-1.12-.69,2.12,2.12,0,0,0-1.18.37,4.74,4.74,0,0,0-.88.73,5.3,5.3,0,0,0-1.16,2,5.38,5.38,0,0,0,0,3.39,4.56,4.56,0,0,0,2.1,2.47,5.22,5.22,0,0,0,5.58-.24l-.37-.51a8.76,8.76,0,0,0-2.77,2.67,3.08,3.08,0,0,0-.16,3,2.25,2.25,0,0,0,1.41,1.28C273.76,129.62,274,129.52,274,129.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.78,56.77s.14.15.46.35a8.51,8.51,0,0,0,1.45.74,4,4,0,0,0,2.62.23,3.17,3.17,0,0,0,1.44-.91,2.19,2.19,0,0,0,.55-1.88l-.39.33a2.73,2.73,0,1,0,2-5.08l-.15.7a3,3,0,0,0,3.07-2.57,3.35,3.35,0,0,0-2.28-3.59,3.92,3.92,0,0,0-1.89-.23l.21.72a3.61,3.61,0,1,0-4.38-5.46h.5a4.1,4.1,0,0,0-4.1-1.32,3.85,3.85,0,0,0-2.78,4.27,1.39,1.39,0,0,0,.24.7,4.63,4.63,0,0,1,.37-2.65A3.33,3.33,0,0,1,230,39.3a3.59,3.59,0,0,1,3.49,1.21l.25.32.25-.33a3.13,3.13,0,0,1,4.4-.28,3,3,0,0,1-.85,4.67l-2.18,1,2.39-.29a3,3,0,0,1,1.51.19,2.57,2.57,0,0,1,1.81,2.73,2.33,2.33,0,0,1-2.26,2l-3.09-.31,2.94,1a2.15,2.15,0,0,1,1.18,2.87,2.22,2.22,0,0,1-2.68,1l-.52-.22.12.54a2.14,2.14,0,0,1-1.57,2.24,3.9,3.9,0,0,1-2.37-.1C231.5,57.11,230.81,56.7,230.78,56.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.1,114.32c-.22-.12-9-3.71-9.7,5.6s8.84,8.06,8.87,7.79S214.1,114.32,214.1,114.32Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.67,124s-.17.1-.45.21a1.69,1.69,0,0,1-1.22-.06c-1-.43-1.68-2-1.6-3.74a5.43,5.43,0,0,1,.61-2.29,1.9,1.9,0,0,1,1.31-1.16.84.84,0,0,1,.93.51c.1.27,0,.45.08.47s.21-.14.16-.53a1,1,0,0,0-.32-.61,1.29,1.29,0,0,0-.88-.3,2.29,2.29,0,0,0-1.8,1.33,5.52,5.52,0,0,0-.74,2.56c-.08,1.88.76,3.7,2.08,4.19a1.75,1.75,0,0,0,1.5-.15C210.64,124.2,210.7,124,210.67,124Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.26,129.4a3.23,3.23,0,0,1,5.17,1,3.08,3.08,0,0,1,0,2.47,2.92,2.92,0,0,1-2.9,1.62,2.87,2.87,0,0,1-2.42-2.27c-.22-1.17-.59-2.55.45-3.11",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.12,127c.35,0,.51,2.3,2.63,3.84s4.6,1.11,4.65,1.43c0,.15-.53.5-1.59.59a5.78,5.78,0,0,1-3.86-1.06,5.07,5.07,0,0,1-2.06-3.23C237.74,127.61,238,127,238.12,127Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.17,157.07l6.35-1.07,35.73,3.17L258,165.23l3.39,2s-13.29,18.5-26.91,17.5-37.14-20.42-37.14-20.42l-.11-6.35Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,187.28,274.79,170.4c-3.62-1.2-20.49-6.93-20.49-6.93s-13.1,20.8-23.94,19.46c-5.86-.72-13-5.79-18.27-10.28a54.33,54.33,0,0,1-11.46-13.54l-1.18-2c-5.13,0-21.09,3.85-26.73,5.26a7.07,7.07,0,0,0-3.5,2.06c-3.13,3.35-9.18,9.73-10.46,16-1.23,6-6.24,25.31-6.24,25.31l143.79-4.4Z",
    style: {
      fill: "#397E32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,187.77c-2.19,1-20.31,7.17-21.12,8.09S303.41,188,303.41,188l-7.1,13.45,64.1-1.39Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.79,183.41c-.09,0-.39-1.15-1.27-2.87a23.49,23.49,0,0,0-4.54-6,54,54,0,0,0-5.86-4.78,19.87,19.87,0,0,1-2.49-1.93,17.81,17.81,0,0,1,2.7,1.62,40.81,40.81,0,0,1,6,4.72,21,21,0,0,1,4.51,6.18,12.82,12.82,0,0,1,.79,2.18A2.56,2.56,0,0,1,186.79,183.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.1,196.2a15.62,15.62,0,0,1-.18-3c0-1.85,0-4.4.12-7.22s.36-5.36.56-7.19a15.75,15.75,0,0,1,.47-3,19.84,19.84,0,0,1-.1,3c-.11,2-.25,4.47-.4,7.19s-.2,5.19-.28,7.19A17.32,17.32,0,0,1,273.1,196.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.24,166.83s-.06.11-.21.29a5.09,5.09,0,0,1-.74.73,8.25,8.25,0,0,1-3.38,1.71,9.12,9.12,0,0,1-5.61-.36,8.65,8.65,0,0,1-2.8-1.87c-.85-.8-1.61-1.71-2.49-2.51a9,9,0,0,0-6-2.42,8.73,8.73,0,0,0-5.13,1.55,9.52,9.52,0,0,0-2.59,2.62c-.48.73-.67,1.19-.72,1.17a1.21,1.21,0,0,1,.1-.35,8.1,8.1,0,0,1,.45-.93,9.11,9.11,0,0,1,7.89-4.54,9.38,9.38,0,0,1,6.38,2.52c.91.83,1.67,1.75,2.49,2.52a8.51,8.51,0,0,0,2.63,1.8,9,9,0,0,0,8.69-1.07C204.88,167.18,205.19,166.78,205.24,166.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.11,182.47s-.31-.54-1-1.48a12.56,12.56,0,0,0-3.93-3.27,12.15,12.15,0,0,0-7.87-1.32,12.52,12.52,0,0,0-8.44,6.06,10.55,10.55,0,0,0-1.44,5.95,6.34,6.34,0,0,0,1,3,5.08,5.08,0,0,0,2.65,1.94,3.72,3.72,0,0,0,3.26-.51,4.93,4.93,0,0,0,1.95-2.89,5.39,5.39,0,0,0-.46-3.58,7.56,7.56,0,0,0-2.44-2.89,10.79,10.79,0,0,0-7.63-1.7,17.33,17.33,0,0,0-7.73,3.1c-4.78,3.21-8.55,8.09-13.86,11.37a18,18,0,0,1-8.71,2.77,18.48,18.48,0,0,1-8.72-1.67,14.83,14.83,0,0,1-6.5-5.56,10.13,10.13,0,0,1-1.23-8.05,7.76,7.76,0,0,1,5.19-5.64,7.34,7.34,0,0,1,7,1.74,5.63,5.63,0,0,1,1.54,3.22,6.56,6.56,0,0,1-.55,3.38,8.79,8.79,0,0,1-4.5,4.45,10.7,10.7,0,0,1-5.74.57,17.57,17.57,0,0,1-4.89-1.61,44.92,44.92,0,0,1-6.87-4.52c-1.8-1.36-3.22-2.37-4.23-3-.5-.31-.88-.55-1.15-.7s-.39-.24-.39-.24.15.06.42.2.67.35,1.18.65c1,.61,2.48,1.59,4.29,2.92a44.42,44.42,0,0,0,6.87,4.42,17.36,17.36,0,0,0,4.82,1.55,10.38,10.38,0,0,0,5.55-.58,8.42,8.42,0,0,0,4.27-4.27,6.24,6.24,0,0,0,.51-3.17,5.15,5.15,0,0,0-1.44-3,6.86,6.86,0,0,0-6.59-1.61,7.31,7.31,0,0,0-4.86,5.32,9.71,9.71,0,0,0,1.19,7.67,14.46,14.46,0,0,0,6.29,5.36,18.15,18.15,0,0,0,8.49,1.62,17.59,17.59,0,0,0,8.45-2.7c5.21-3.21,9-8.08,13.85-11.35a17.87,17.87,0,0,1,8-3.18,11.31,11.31,0,0,1,8,1.81,8.11,8.11,0,0,1,2.59,3.08,6,6,0,0,1,.47,3.89,5.36,5.36,0,0,1-2.14,3.15,4.2,4.2,0,0,1-3.63.56,5.59,5.59,0,0,1-2.87-2.12,6.73,6.73,0,0,1-1.11-3.25,10.86,10.86,0,0,1,1.52-6.16,12.84,12.84,0,0,1,8.71-6.17,12.26,12.26,0,0,1,8,1.43,12.4,12.4,0,0,1,3.93,3.39A8.48,8.48,0,0,1,272.11,182.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.67,180.72a2.87,2.87,0,0,1-.32.82,11.51,11.51,0,0,1-1.29,2.05,12.85,12.85,0,0,1-2.58,2.49,17.2,17.2,0,0,1-3.85,2.11,15.81,15.81,0,0,1-7.86.95,14.15,14.15,0,0,1-2.35-.54,2.37,2.37,0,0,1-.81-.35c0-.09,1.21.33,3.2.52a16.57,16.57,0,0,0,7.63-1.07,15.83,15.83,0,0,0,6.34-4.35C292.06,181.83,292.58,180.67,292.67,180.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,187s-.32-.16-.93-.32a5.12,5.12,0,0,0-2.6.06,10.75,10.75,0,0,0-3.44,1.88c-1.21.9-2.5,1.94-3.8,3.09a58,58,0,0,0-6.19,6.4c-1.47,1.75-2.29,2.9-2.36,2.86a4,4,0,0,1,.49-.88c.35-.53.88-1.3,1.58-2.21a47.21,47.21,0,0,1,6.13-6.56,46.44,46.44,0,0,1,3.87-3.08,10.33,10.33,0,0,1,3.63-1.85,4.86,4.86,0,0,1,2.75.1A1.85,1.85,0,0,1,302,187Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.15,167.43a4.08,4.08,0,0,1-1.42,1.08,11.77,11.77,0,0,1-8.38,1.2,4.12,4.12,0,0,1-1.67-.64,19.62,19.62,0,0,0,5.9.31A19.4,19.4,0,0,0,262.15,167.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.91,202.21a39.46,39.46,0,0,0-.18-4.41,19.77,19.77,0,0,0-4-9.65,21.06,21.06,0,0,0-4.18-4,17.67,17.67,0,0,0-4.2-2.21,33.45,33.45,0,0,0-4.27-1.08,4.33,4.33,0,0,1,1.19,0,14.88,14.88,0,0,1,3.2.69,16.93,16.93,0,0,1,4.35,2.17,20.22,20.22,0,0,1,4.32,4.1,19.16,19.16,0,0,1,4,9.93,16.83,16.83,0,0,1,0,3.27A4.78,4.78,0,0,1,175.91,202.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186.09,197.17a5.4,5.4,0,0,0-5.55-.58c-.75.36-1.41.9-2.18,1.23a2.33,2.33,0,0,1-2.38-.14c-.56-.47-.72-1.27-1.15-1.86-.81-1.09-2.4-1.26-3.74-1a17,17,0,0,1-4,.65,21.54,21.54,0,0,1-3.87-1.11,8,8,0,0,0-8.1,2.65l-2.42,7.16L188,202.39A5.4,5.4,0,0,0,186.09,197.17Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198,201.78c-.09,0-.4-.93-1.37-2.19a9.19,9.19,0,0,0-11-2.93c-1.47.61-2.22,1.3-2.28,1.22s.15-.21.49-.51a8.22,8.22,0,0,1,1.64-1.05,9,9,0,0,1,11.47,3.05,7.79,7.79,0,0,1,.9,1.72A1.77,1.77,0,0,1,198,201.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.69,198.16a14.88,14.88,0,0,1-6.52-3.09c-1.77-1.65-2.77-4.36-1.8-6.59A20.89,20.89,0,0,1,254.46,201l34.12-.56A29.23,29.23,0,0,0,281.69,198.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M241.93,113.36a22.73,22.73,0,0,0-.47-2.5,10.31,10.31,0,0,0-3.87-5.52,10.16,10.16,0,0,0-9.63-1.25,10,10,0,0,0-4.63,3.61,10.07,10.07,0,0,0,.2,11.94,9.48,9.48,0,0,0,2.17,2.12,9.77,9.77,0,0,0,2.58,1.34,10.25,10.25,0,0,0,13.27-7.23,24.66,24.66,0,0,0,.38-2.51,8.22,8.22,0,0,1-.18,2.55,10.38,10.38,0,0,1-3.66,5.9,10.48,10.48,0,0,1-10,1.74,10.6,10.6,0,0,1-5-3.6,10.57,10.57,0,0,1-.21-12.55,10.6,10.6,0,0,1,4.88-3.76,10.51,10.51,0,0,1,5.55-.53,10.46,10.46,0,0,1,8.32,7.7A8.17,8.17,0,0,1,241.93,113.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.92,112.91a23.76,23.76,0,0,0-.47-2.5,10.26,10.26,0,0,0-3.88-5.51,10.07,10.07,0,0,0-4.31-1.81,10.23,10.23,0,0,0-5.31.55,9.56,9.56,0,0,0-2.54,1.43,9.28,9.28,0,0,0-2.09,2.19,10,10,0,0,0,.2,11.94,9.43,9.43,0,0,0,2.17,2.11,9.08,9.08,0,0,0,2.58,1.34,10.14,10.14,0,0,0,9.58-1.58,10.34,10.34,0,0,0,3.69-5.65,23.78,23.78,0,0,0,.38-2.51,8.15,8.15,0,0,1-.19,2.56,10.25,10.25,0,0,1-3.65,5.89,10.47,10.47,0,0,1-10,1.75,10.09,10.09,0,0,1-2.71-1.39,10,10,0,0,1-2.29-2.21A10.53,10.53,0,0,1,248.9,107a10,10,0,0,1,2.21-2.29,10.28,10.28,0,0,1,2.66-1.48,10.64,10.64,0,0,1,5.56-.52,10.47,10.47,0,0,1,8.32,7.69A8.18,8.18,0,0,1,267.92,112.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.37,111.65a12.83,12.83,0,0,1-3.77,1.64,13.2,13.2,0,0,1-4,.86,22.1,22.1,0,0,1,3.85-1.36A23.51,23.51,0,0,1,221.37,111.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.26,110.4a18.83,18.83,0,0,0-3.43-.16,18.08,18.08,0,0,0-3.29,1,4.76,4.76,0,0,1,3.23-1.49A4.7,4.7,0,0,1,248.26,110.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.12,121.32a3.48,3.48,0,0,1-1.65-.61,8,8,0,0,1-4-7.14,3.39,3.39,0,0,1,.33-1.72c.08,0,0,.67,0,1.72a8.75,8.75,0,0,0,3.86,6.83C227.53,121,228.15,121.24,228.12,121.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.83,120.58a3.25,3.25,0,0,1-1.54-.6,7.82,7.82,0,0,1-2.8-2.86,8,8,0,0,1-1-3.87,3.25,3.25,0,0,1,.28-1.63,12.78,12.78,0,0,1,.09,1.61,9,9,0,0,0,1.11,3.63,8.85,8.85,0,0,0,2.54,2.81A13.29,13.29,0,0,1,253.83,120.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,203.61S109,364.4,131.19,472.55l276.73-.86L335.48,202.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,203.61l223.82-1.5h.16l.05.15c20.63,76.7,45.54,169.25,72.48,269.36l.09.33h-.34l-22,.07-254.73.76H131l0-.18q-1.4-7.46-2.75-14.75c-.43-2.44-.93-4.85-1.31-7.27s-.73-4.82-1.1-7.21q-1.08-7.19-2.15-14.19-.89-7-1.75-13.9-.43-3.42-.86-6.81c-.28-2.26-.49-4.51-.73-6.74q-.69-6.71-1.37-13.22c-.49-4.34-.79-8.64-1.17-12.87s-.72-8.39-1.07-12.48c-2.54-32.81-3.72-61.51-4.41-85.15s-.79-42.25-.8-54.94c0-6.35,0-11.21.07-14.49q0-2.46.06-3.72c0-.79,0-1.14,0-1.25,0,.48,0,6.83,0,19.46s.22,31.29.92,54.93,2,52.33,4.52,85.13c.36,4.09.72,8.26,1.08,12.48s.69,8.52,1.18,12.86.92,8.75,1.39,13.21c.24,2.23.45,4.48.73,6.74s.57,4.53.86,6.81q.87,6.87,1.76,13.89c.72,4.67,1.43,9.4,2.16,14.18q.56,3.58,1.11,7.21c.37,2.42.88,4.83,1.31,7.26q1.36,7.29,2.75,14.74l-.22-.18,254.73-.84,22-.06-.25.32c-26.9-100.11-51.78-192.68-72.39-269.37l.21.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,203.61s-.23,21.19,3.36,58.92c2.37,25,2.11,57.75,8.73,99.53,14,88.27,21.35,101.77,21.35,101.77L415,462,343.17,199.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.66,203.61l231.51-4.17h.17l0,.16C364,274.7,388.68,364.86,415.29,462l.09.33h-.33l-14.71.1L145.1,464.05H145l-.06-.12a57.24,57.24,0,0,1-2.48-7c-.72-2.33-1.35-4.68-2-7s-1.2-4.66-1.75-7-1.08-4.63-1.6-6.93Q134,422.23,131.59,409c-3.3-17.67-6.08-34.5-8.55-50.34-1.21-7.92-2.17-15.62-3-23.08s-1.42-14.64-1.91-21.56c-1-13.85-1.55-26.59-2.27-38.08-.34-5.75-.8-11.18-1.28-16.29s-.86-9.9-1.19-14.36c-.67-8.93-1.1-16.53-1.36-22.7s-.38-10.9-.42-14.09c0-1.6,0-2.81,0-3.62s0-1.22,0-1.22c0,.23,0,1.7.07,4.83s.2,7.93.49,14.09.74,13.77,1.43,22.69c.34,4.46.74,9.26,1.22,14.36s.95,10.54,1.3,16.29c.74,11.5,1.31,24.24,2.33,38.07q.75,10.38,1.93,21.56c.79,7.44,1.76,15.14,3,23.06,2.48,15.83,5.27,32.65,8.59,50.31q2.46,13.26,5.53,27.07c.51,2.3,1,4.62,1.6,6.93s1.14,4.65,1.75,7,1.25,4.66,2,7a56.78,56.78,0,0,0,2.45,6.88l-.2-.12,255.23-1.72,14.71-.1-.25.33C388.2,365,363.52,274.82,343,199.72l.21.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.59,212.13l-255.71,4.35C110.8,285.83,135.22,394.07,153.12,451l268.36-2.81C394,375.24,362.41,292.3,367.59,212.13Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.59,212.13c0,.23,0,1.56-.13,4.45,0,1.47-.11,3.3-.18,5.48s-.25,4.71-.13,7.56c.13,5.71.08,12.76.79,21q.21,3.1.43,6.43c.22,2.21.49,4.5.75,6.86s.54,4.79.82,7.29.74,5.07,1.12,7.7.81,5.35,1.24,8.12,1.05,5.59,1.59,8.49,1.06,5.87,1.74,8.87,1.36,6.08,2.06,9.22c.36,1.57.7,3.16,1.09,4.75l1.22,4.82q1.25,4.86,2.53,9.91t2.88,10.21c.49,1.73,1,3.48,1.49,5.23l1.61,5.29c8.55,28.5,20.22,60,33.18,94.3l.11.3h-.32L162,451.18l-8.9.09h-.2l-.05-.18c-6.47-20.85-12-41.63-16.85-62.09s-9.11-40.62-12.69-60.34-6.5-39-8.59-57.76a441.43,441.43,0,0,1-3.09-54.42v-.22h.22l255.71-4.13-255.7,4.58.22-.22a440.77,440.77,0,0,0,3.12,54.36c2.09,18.73,5,38,8.61,57.72s7.81,39.86,12.69,60.31,10.38,41.22,16.84,62.05l-.25-.18,8.91-.09L421.48,448l-.21.3c-12.94-34.3-24.58-65.83-33.11-94.35-.54-1.78-1.07-3.55-1.61-5.3s-1-3.51-1.48-5.24l-2.87-10.21q-1.27-5.06-2.52-9.92c-.41-1.62-.81-3.23-1.22-4.82s-.72-3.19-1.07-4.76c-.7-3.14-1.39-6.21-2.06-9.23s-1.16-6-1.73-8.88-1.1-5.72-1.57-8.49L370.8,279c-.37-2.64-.84-5.2-1.11-7.7s-.54-4.95-.8-7.31-.52-4.65-.73-6.86-.29-4.37-.42-6.43c-.68-8.27-.62-15.32-.73-21-.1-2.86.12-5.36.17-7.54s.16-4,.22-5.47C367.53,213.71,367.58,212.36,367.59,212.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.06,199.24l-256.4,4.37c-1.08,69.34,10.29,133.05,28.2,190l74,45.82,214.77-3.66C401.13,362.8,362.88,279.41,368.06,199.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.06,199.24c0,.23-.06,1.58-.18,4.49-.07,1.49-.16,3.35-.17,5.54s-.1,4.74,0,7.62a294.49,294.49,0,0,0,5.08,49.6c3.85,21.18,10.63,46.49,20.42,74.85,4.87,14.19,10.45,29.15,16.5,44.87s12.59,32.17,19.12,49.47l.11.3h-.32l-214.76,3.7h-.08l-.06,0-32-19.84-41.94-26-.08-.05,0-.09a621,621,0,0,1-22.41-98.57,592.34,592.34,0,0,1-5.76-91.51v-.22h.22l256.4-4.14-256.39,4.59.22-.22A594,594,0,0,0,117.7,295a621,621,0,0,0,22.4,98.48l-.11-.14,41.94,26,32,19.85-.14,0,214.76-3.62-.2.3c-6.52-17.3-13.05-33.77-19.08-49.49s-11.61-30.69-16.47-44.89c-9.76-28.38-16.51-53.72-20.32-74.92a288.29,288.29,0,0,1-5-49.65c-.08-2.88,0-5.43.05-7.62s.12-4,.2-5.52C368,200.83,368.05,199.47,368.06,199.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.07 393.58 205.22 386.58 213.83 439.42 140.07 393.58",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.83,439.42a1,1,0,0,1-.06-.26c0-.21-.09-.46-.16-.78l-.54-3c-.45-2.67-1.1-6.47-1.9-11.19-1.57-9.52-3.75-22.71-6.21-37.55l.29.22-6.07.65-41.94,4.43-12.71,1.28-3.46.33-.9.07h-.31a1.21,1.21,0,0,1,.3-.06l.9-.12,3.45-.42,12.69-1.45L199.13,387l6.06-.65.25,0,0,.24c2.38,14.85,4.5,28,6,37.58.73,4.72,1.33,8.54,1.74,11.21q.28,1.94.45,3l.1.79A.69.69,0,0,1,213.83,439.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93,271.56c0,.14-34.55.85-77.16,1.58s-77.18,1.19-77.18,1.05,34.54-.85,77.17-1.57S319.93,271.42,319.93,271.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.24,295.61c0,.14-34.55.85-77.17,1.58s-77.17,1.19-77.17,1.05,34.54-.85,77.17-1.58S324.23,295.47,324.24,295.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.9,319.57c0,.14-34.55.85-77.16,1.57s-77.18,1.2-77.18,1.06,34.54-.85,77.17-1.58S333.9,319.42,333.9,319.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,346.73c0,.15-34.55.85-77.16,1.58s-77.18,1.2-77.18,1.05,34.54-.84,77.17-1.57S344,346.59,344,346.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.46,372c0,.14-34.55.85-77.16,1.57s-77.18,1.2-77.18,1.06,34.54-.85,77.17-1.58S355.46,371.85,355.46,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.74,203.56s3.05-4.35,4.73-5.29,4-1,5.07-.09l1.06.9s5.3-2.57,7.93-.79c0,0,5-2.56,7.56.13,0,0,3.86-2.67,5.59-.49s1.67,6,.92,7.93-2.07,8.64-3.24,8.79c0,0-3.13.42-3.59-1.26s-.67-2.5-.67-2.5-1,6-2.46,6.38-4.2.25-4.37-2.38c0,0-1.28,2-2.61,1.49s-3-1.45-2.87-3.08.07-3.27.07-3.27-.65,2.4-1.85,1.92-2.39-.34-3.11-2.33-2.55-5.92-2.55-5.92Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.76,209.91c-.08,0,.22-.66.46-1.72a9.35,9.35,0,0,0-1.71-7.93c-.66-.86-1.18-1.3-1.13-1.37s.65.3,1.41,1.14a8.46,8.46,0,0,1,2,3.89,8.57,8.57,0,0,1-.2,4.37A3.75,3.75,0,0,1,134.76,209.91Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.87,198.31a8.34,8.34,0,0,1,.75,2.35,23.41,23.41,0,0,1-.45,11.79,7.92,7.92,0,0,1-.93,2.27,42.42,42.42,0,0,0,1.39-8.16A42.68,42.68,0,0,0,140.87,198.31Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.22,198.49a25.14,25.14,0,0,1-1.08,12.56c-.15,0,.53-2.79.82-6.25S148.06,198.51,148.22,198.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.38,199.23a2,2,0,0,0-1.39-1,4.37,4.37,0,0,0-3.86,1.15,13.09,13.09,0,0,0-2.46,3.38l7.32-.06C168.89,201.49,169.83,200.3,169.38,199.23Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.83,450.13c-.08-.07,1.19-1.44,2.81-3.94a34.94,34.94,0,0,0,2.48-4.61,35.1,35.1,0,0,0,3-12.38A33.43,33.43,0,0,0,455,424c-.29-3-.81-4.76-.7-4.79a7,7,0,0,1,.39,1.25,12.33,12.33,0,0,1,.35,1.49c.11.59.26,1.26.33,2a31.91,31.91,0,0,1,.23,5.29,35.79,35.79,0,0,1-.89,6.42,36.64,36.64,0,0,1-2.12,6.13,32.21,32.21,0,0,1-2.61,4.61c-.41.64-.85,1.16-1.21,1.64a13.9,13.9,0,0,1-1,1.17A6.33,6.33,0,0,1,446.83,450.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,455.83c-.06-.06,1.19-1.2,3-3.24a44.77,44.77,0,0,0,9.69-18.54c.66-2.62.88-4.29,1-4.27A6.13,6.13,0,0,1,445,431a28,28,0,0,1-.54,3.18,40.57,40.57,0,0,1-9.77,18.7,28.51,28.51,0,0,1-2.31,2.26A4.34,4.34,0,0,1,431.45,455.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.1,
    cy: 262.11,
    r: 37.17,
    transform: "translate(-74.72 178.96) rotate(-24.42)",
    style: {
      fill: "#397E32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.19,249.15q.22,12.93.44,25.86c.06,3.21,5.06,3.22,5,0q-.21-12.93-.44-25.86c-.05-3.21-5.05-3.22-5,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.08,264.82l27.67-.48c3.21,0,3.22-5,0-5l-27.67.48c-3.21.05-3.22,5.05,0,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M383,225.5a35.09,35.09,0,0,0-21,2.21,47.12,47.12,0,0,0,4.87,6.89c1.56,1.94,3.9,4,6.25,3.13a5.87,5.87,0,0,1,1.94-.66c1.06,0,1.77,1.05,2.36,1.94a23.17,23.17,0,0,0,5.9,6.07c1.25.89,3.14,1.58,4.15.43a3.27,3.27,0,0,0,.57-2.15C388.12,237.67,385.57,230.58,383,225.5Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M350.19,187.77l6-1.8a16.21,16.21,0,0,1,14.07,2.67c3.26,2.45,6.75,5.24,7.87,6.76l5.14,6.91a5.93,5.93,0,0,1,1,5.28,1.72,1.72,0,0,1-.58,1l-1.82,2.64s.54,4,.56,6.55-2.46,6.9-2.46,6.9l4.86,13.27a3.29,3.29,0,0,1-.79,3.56,1.39,1.39,0,0,1-2,.11c-1.91-1.54-7-12.36-7-12.36l-2-2.32-2.77-.69s.5,4-1.3,4.79l-7.61-6.56-5.89-10s-.16-13.68-1.64-17.46Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.38,214.21a21.9,21.9,0,0,1,3.55,10.49c-.15,0-.61-2.42-1.59-5.3S376.25,214.29,376.38,214.21Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.79,208.07c.16-.07.72,1.24,1,2.9a8.34,8.34,0,0,1,.3,3.06,10,10,0,0,1-.81-2.95A18,18,0,0,1,380.79,208.07Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.2,231.66a26.93,26.93,0,0,1-1.66-2.72c-1-1.7-2.42-4-4.07-6.51-.82-1.26-1.63-2.44-2.37-3.51a10.67,10.67,0,0,0-2.24-2.52,5.36,5.36,0,0,0-2.88-1,1.6,1.6,0,0,1,.86-.09,4.68,4.68,0,0,1,2.23.83,10.21,10.21,0,0,1,2.42,2.54c.77,1.06,1.59,2.24,2.42,3.5,1.65,2.51,3,4.87,3.95,6.62A14.8,14.8,0,0,1,376.2,231.66Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.78,216.55c.08,0,.16.79.56,2a11.44,11.44,0,0,0,2.51,4.21,14.59,14.59,0,0,1,1.9,2.06,4.19,4.19,0,0,1,.7,2.25,4.45,4.45,0,0,1-.31,2.09c-.09,0,.05-.81-.06-2.06a4,4,0,0,0-.72-2,17.09,17.09,0,0,0-1.89-2,10.2,10.2,0,0,1-2.48-4.46A4.71,4.71,0,0,1,364.78,216.55Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.8,202.38c-.15,0,0-2.38-.45-5.26s-1.14-5.16-.92-5.19a5.94,5.94,0,0,1,.6,1.43,21.56,21.56,0,0,1,.84,3.69A13.47,13.47,0,0,1,354.8,202.38Z",
    style: {
      fill: "#eb996e"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M475.82,471.54c0,.14-98.16.49-219.23.77s-219.24.39-219.24.24,98.14-.48,219.24-.76S475.82,471.39,475.82,471.54Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.711bf7deeca624fbf9c740e7b886bcc7.svg";
export { ForwardRef as ReactComponent };